import * as React from "react"
import Svg, { Defs, LinearGradient, Stop, Path } from "react-native-svg"

function SSLogo(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <Defs>
        <LinearGradient
          id="a"
          x1={272.07}
          y1={332.76}
          x2={1130.67}
          y2={842.77}
          gradientTransform="rotate(-.27 893.93 672.682)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop offset={0} stopColor="#d7e4f6" />
          <Stop offset={0.5} stopColor="#bbd2ee" />
          <Stop offset={0.56} stopColor="#b7cfed" />
          <Stop offset={1} stopColor="#a0c2e7" />
        </LinearGradient>
        <LinearGradient
          id="c"
          x1={669.73}
          y1={632.61}
          x2={443.35}
          y2={477.61}
          xlinkHref="#a"
        />
        <LinearGradient
          id="b"
          x1={580.87}
          y1={661.41}
          x2={872.87}
          y2={661.41}
          gradientUnits="userSpaceOnUse"
        >
          <Stop offset={0} stopColor="#00b70c" />
          <Stop offset={0.05} stopColor="#08b914" />
          <Stop offset={0.14} stopColor="#1fbf2a" />
          <Stop offset={0.24} stopColor="#44c94e" />
          <Stop offset={0.36} stopColor="#78d781" />
          <Stop offset={0.49} stopColor="#b9e9c1" />
          <Stop offset={0.5} stopColor="#bfebc6" />
          <Stop offset={0.53} stopColor="#a9e0b0" />
          <Stop offset={0.62} stopColor="#76c77d" />
          <Stop offset={0.7} stopColor="#4bb352" />
          <Stop offset={0.79} stopColor="#2aa331" />
          <Stop offset={0.86} stopColor="#13981a" />
          <Stop offset={0.94} stopColor="#04910b" />
          <Stop offset={1} stopColor="#008f07" />
        </LinearGradient>
        <LinearGradient
          id="d"
          x1={583.4}
          y1={665.92}
          x2={871.27}
          y2={665.92}
          xlinkHref="#b"
        />
        <LinearGradient
          id="e"
          x1={567.33}
          y1={441.73}
          x2={574.92}
          y2={441.73}
          xlinkHref="#b"
        />
        <LinearGradient
          id="f"
          x1={589.21}
          y1={661.27}
          x2={869.79}
          y2={661.27}
          xlinkHref="#b"
        />
        <LinearGradient
          id="g"
          x1={591.86}
          y1={661.93}
          x2={865.14}
          y2={661.93}
          xlinkHref="#b"
        />
        <LinearGradient
          id="h"
          x1={577.22}
          y1={492.05}
          x2={580.44}
          y2={492.05}
          xlinkHref="#b"
        />
        <LinearGradient
          id="i"
          x1={577.8}
          y1={649.19}
          x2={871.61}
          y2={649.19}
          xlinkHref="#b"
        />
        <LinearGradient
          id="j"
          x1={579.88}
          y1={652.26}
          x2={871.69}
          y2={652.26}
          xlinkHref="#b"
        />
        <LinearGradient
          id="k"
          x1={574.93}
          y1={509.6}
          x2={602.31}
          y2={509.6}
          xlinkHref="#b"
        />
        <LinearGradient
          id="l"
          x1={577.5}
          y1={500.61}
          x2={590.29}
          y2={500.61}
          xlinkHref="#b"
        />
        <LinearGradient
          id="m"
          x1={579.71}
          y1={502.38}
          x2={588.8}
          y2={502.38}
          xlinkHref="#b"
        />
        <LinearGradient
          id="n"
          x1={587.28}
          y1={649.97}
          x2={871.84}
          y2={649.97}
          xlinkHref="#b"
        />
        <LinearGradient
          id="o"
          x1={570.89}
          y1={476.49}
          x2={575.43}
          y2={476.49}
          xlinkHref="#b"
        />
        <LinearGradient
          id="p"
          x1={571.32}
          y1={637.89}
          x2={871.3}
          y2={637.89}
          xlinkHref="#b"
        />
        <LinearGradient
          id="q"
          x1={583.51}
          y1={497.79}
          x2={587.24}
          y2={497.79}
          xlinkHref="#b"
        />
        <LinearGradient
          id="r"
          x1={574.42}
          y1={492.34}
          x2={589.56}
          y2={492.34}
          xlinkHref="#b"
        />
        <LinearGradient
          id="s"
          x1={584.04}
          y1={497.76}
          x2={587.18}
          y2={497.76}
          xlinkHref="#b"
        />
        <LinearGradient
          id="t"
          x1={577.07}
          y1={494.19}
          x2={588.05}
          y2={494.19}
          xlinkHref="#b"
        />
        <LinearGradient
          id="u"
          x1={579.56}
          y1={495.63}
          x2={587.51}
          y2={495.63}
          xlinkHref="#b"
        />
        <LinearGradient
          id="v"
          x1={865.38}
          y1={801.33}
          x2={871.12}
          y2={801.33}
          xlinkHref="#b"
        />
        <LinearGradient
          id="w"
          x1={566.95}
          y1={492.99}
          x2={603.86}
          y2={492.99}
          xlinkHref="#b"
        />
        <LinearGradient
          id="x"
          x1={583.05}
          y1={491.92}
          x2={586.68}
          y2={491.92}
          xlinkHref="#b"
        />
        <LinearGradient
          id="y"
          x1={580.99}
          y1={489.37}
          x2={585.68}
          y2={489.37}
          xlinkHref="#b"
        />
        <LinearGradient
          id="z"
          x1={570.59}
          y1={476.26}
          x2={577.11}
          y2={476.26}
          xlinkHref="#b"
        />
        <LinearGradient
          id="A"
          x1={582.92}
          y1={491.9}
          x2={586.75}
          y2={491.9}
          xlinkHref="#b"
        />
        <LinearGradient
          id="B"
          x1={581.59}
          y1={489.47}
          x2={585.57}
          y2={489.47}
          xlinkHref="#b"
        />
        <LinearGradient
          id="C"
          x1={573.71}
          y1={479.83}
          x2={578.88}
          y2={479.83}
          xlinkHref="#b"
        />
        <LinearGradient
          id="D"
          x1={584.48}
          y1={496.48}
          x2={586.7}
          y2={496.48}
          xlinkHref="#b"
        />
        <LinearGradient
          id="E"
          x1={576.63}
          y1={483.38}
          x2={580.85}
          y2={483.38}
          xlinkHref="#b"
        />
        <LinearGradient
          id="F"
          x1={579.45}
          y1={489.35}
          x2={586.1}
          y2={489.35}
          xlinkHref="#b"
        />
        <LinearGradient
          id="G"
          x1={854.1}
          y1={785.86}
          x2={871.62}
          y2={785.86}
          xlinkHref="#b"
        />
        <LinearGradient
          id="H"
          x1={865.74}
          y1={797.28}
          x2={871.4}
          y2={797.28}
          xlinkHref="#b"
        />
        <LinearGradient
          id="I"
          x1={889.68}
          y1={830.15}
          x2={894.41}
          y2={830.15}
          xlinkHref="#b"
        />
        <LinearGradient
          id="J"
          x1={889.5}
          y1={829.1}
          x2={892.47}
          y2={829.1}
          xlinkHref="#b"
        />
        <LinearGradient
          id="K"
          x1={584.77}
          y1={637.27}
          x2={871.43}
          y2={637.27}
          xlinkHref="#b"
        />
        <LinearGradient
          id="L"
          x1={561.48}
          y1={461.6}
          x2={567.55}
          y2={461.6}
          xlinkHref="#b"
        />
        <LinearGradient
          id="M"
          x1={583.06}
          y1={484.79}
          x2={586.04}
          y2={484.79}
          xlinkHref="#b"
        />
        <LinearGradient
          id="N"
          x1={561.72}
          y1={484.93}
          x2={604.03}
          y2={484.93}
          xlinkHref="#b"
        />
        <LinearGradient
          id="O"
          x1={580.09}
          y1={483.6}
          x2={584.69}
          y2={483.6}
          xlinkHref="#b"
        />
        <LinearGradient
          id="P"
          x1={577.84}
          y1={478.07}
          x2={580.52}
          y2={478.07}
          xlinkHref="#b"
        />
        <LinearGradient
          id="Q"
          x1={579.41}
          y1={482.04}
          x2={583.48}
          y2={482.04}
          xlinkHref="#b"
        />
        <LinearGradient
          id="R"
          x1={856.65}
          y1={780.98}
          x2={872.13}
          y2={780.98}
          xlinkHref="#b"
        />
        <LinearGradient
          id="S"
          x1={565.96}
          y1={476.42}
          x2={586.48}
          y2={476.42}
          xlinkHref="#b"
        />
        <LinearGradient
          id="T"
          x1={579.91}
          y1={483.63}
          x2={584.81}
          y2={483.63}
          xlinkHref="#b"
        />
        <LinearGradient
          id="U"
          x1={578.44}
          y1={479.01}
          x2={580.52}
          y2={479.01}
          xlinkHref="#b"
        />
        <LinearGradient
          id="V"
          x1={579.36}
          y1={481.27}
          x2={583.3}
          y2={481.27}
          xlinkHref="#b"
        />
        <LinearGradient
          id="W"
          x1={569.57}
          y1={472.15}
          x2={575.94}
          y2={472.15}
          xlinkHref="#b"
        />
        <LinearGradient
          id="X"
          x1={582.23}
          y1={488.06}
          x2={584.73}
          y2={488.06}
          xlinkHref="#b"
        />
        <LinearGradient
          id="Y"
          x1={572.94}
          y1={475.61}
          x2={578.24}
          y2={475.61}
          xlinkHref="#b"
        />
        <LinearGradient
          id="Z"
          x1={576.2}
          y1={479.05}
          x2={580.65}
          y2={479.05}
          xlinkHref="#b"
        />
        <LinearGradient
          id="aa"
          x1={579.36}
          y1={482.14}
          x2={584.01}
          y2={482.14}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ab"
          x1={866.38}
          y1={793.11}
          x2={871.94}
          y2={793.11}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ac"
          x1={581.65}
          y1={478.72}
          x2={585.87}
          y2={478.72}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ad"
          x1={579.97}
          y1={476.6}
          x2={583.27}
          y2={476.6}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ae"
          x1={558.89}
          y1={479.06}
          x2={603.77}
          y2={479.06}
          xlinkHref="#b"
        />
        <LinearGradient
          id="af"
          x1={581.69}
          y1={480.61}
          x2={585.98}
          y2={480.61}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ag"
          x1={578.83}
          y1={475.95}
          x2={580.52}
          y2={475.95}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ah"
          x1={579.36}
          y1={478.41}
          x2={583.92}
          y2={478.41}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ai"
          x1={576.36}
          y1={474.22}
          x2={580.52}
          y2={474.22}
          xlinkHref="#b"
        />
        <LinearGradient
          id="aj"
          x1={579.32}
          y1={475.15}
          x2={582}
          y2={475.15}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ak"
          x1={573.79}
          y1={470.34}
          x2={577.33}
          y2={470.34}
          xlinkHref="#b"
        />
        <LinearGradient
          id="al"
          x1={575.77}
          y1={474.04}
          x2={580.54}
          y2={474.04}
          xlinkHref="#b"
        />
        <LinearGradient
          id="am"
          x1={547.5}
          y1={450.79}
          x2={569.88}
          y2={450.79}
          xlinkHref="#b"
        />
        <LinearGradient
          id="an"
          x1={582.14}
          y1={481.01}
          x2={583.99}
          y2={481.01}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ao"
          x1={579.35}
          y1={479.1}
          x2={583.84}
          y2={479.1}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ap"
          x1={576.12}
          y1={474.54}
          x2={580.54}
          y2={474.54}
          xlinkHref="#b"
        />
        <LinearGradient
          id="aq"
          x1={579.38}
          y1={478.21}
          x2={582.19}
          y2={478.21}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ar"
          x1={574.5}
          y1={471.27}
          x2={577.44}
          y2={471.27}
          xlinkHref="#b"
        />
        <LinearGradient
          id="as"
          x1={575.67}
          y1={473.34}
          x2={580.28}
          y2={473.34}
          xlinkHref="#b"
        />
        <LinearGradient
          id="at"
          x1={564.51}
          y1={464.58}
          x2={572.25}
          y2={464.58}
          xlinkHref="#b"
        />
        <LinearGradient
          id="au"
          x1={579.23}
          y1={479.75}
          x2={582.1}
          y2={479.75}
          xlinkHref="#b"
        />
        <LinearGradient
          id="av"
          x1={568.39}
          y1={467.94}
          x2={574.9}
          y2={467.94}
          xlinkHref="#b"
        />
        <LinearGradient
          id="aw"
          x1={572.11}
          y1={471.28}
          x2={577.68}
          y2={471.28}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ax"
          x1={575.62}
          y1={474.34}
          x2={581.33}
          y2={474.34}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ay"
          x1={888.23}
          y1={829.75}
          x2={892.16}
          y2={829.75}
          xlinkHref="#b"
        />
        <LinearGradient
          id="az"
          x1={885.79}
          y1={826.61}
          x2={890.28}
          y2={826.61}
          xlinkHref="#b"
        />
        <LinearGradient
          id="aA"
          x1={885.38}
          y1={825.24}
          x2={888.39}
          y2={825.24}
          xlinkHref="#b"
        />
        <LinearGradient
          id="aB"
          x1={889.51}
          y1={830.6}
          x2={894.45}
          y2={830.6}
          xlinkHref="#b"
        />
        <LinearGradient
          id="aC"
          x1={887.61}
          y1={828.54}
          x2={892.47}
          y2={828.54}
          xlinkHref="#b"
        />
        <LinearGradient
          id="aD"
          x1={880.8}
          y1={816.09}
          x2={886.75}
          y2={816.09}
          xlinkHref="#b"
        />
        <LinearGradient
          id="aE"
          x1={881.83}
          y1={818.57}
          x2={887.85}
          y2={818.57}
          xlinkHref="#b"
        />
        <LinearGradient
          id="aF"
          x1={882.91}
          y1={825.51}
          x2={894.71}
          y2={825.51}
          xlinkHref="#b"
        />
        <LinearGradient
          id="aG"
          x1={883.31}
          y1={826.32}
          x2={889.27}
          y2={826.32}
          xlinkHref="#b"
        />
        <LinearGradient
          id="aH"
          x1={883.78}
          y1={825.67}
          x2={887.87}
          y2={825.67}
          xlinkHref="#b"
        />
        <LinearGradient
          id="aI"
          x1={877.59}
          y1={817.82}
          x2={892.88}
          y2={817.82}
          xlinkHref="#b"
        />
        <LinearGradient
          id="aJ"
          x1={882.69}
          y1={826.49}
          x2={890.53}
          y2={826.49}
          xlinkHref="#b"
        />
        <LinearGradient
          id="aK"
          x1={882.52}
          y1={825.69}
          x2={891.09}
          y2={825.69}
          xlinkHref="#b"
        />
        <LinearGradient
          id="aL"
          x1={881.85}
          y1={822.25}
          x2={886.08}
          y2={822.25}
          xlinkHref="#b"
        />
        <LinearGradient
          id="aM"
          x1={881.49}
          y1={820.6}
          x2={884.18}
          y2={820.6}
          xlinkHref="#b"
        />
        <LinearGradient
          id="aN"
          x1={877.9}
          y1={808.91}
          x2={882.6}
          y2={808.91}
          xlinkHref="#b"
        />
        <LinearGradient
          id="aO"
          x1={883.86}
          y1={828.22}
          x2={891.9}
          y2={828.22}
          xlinkHref="#b"
        />
        <LinearGradient
          id="aP"
          x1={885.23}
          y1={826.84}
          x2={889.94}
          y2={826.84}
          xlinkHref="#b"
        />
        <LinearGradient
          id="aQ"
          x1={883.33}
          y1={825.45}
          x2={889.74}
          y2={825.45}
          xlinkHref="#b"
        />
        <LinearGradient
          id="aR"
          x1={878.41}
          y1={811.64}
          x2={883.47}
          y2={811.64}
          xlinkHref="#b"
        />
        <LinearGradient
          id="aS"
          x1={879.08}
          y1={814.37}
          x2={884.43}
          y2={814.37}
          xlinkHref="#b"
        />
        <LinearGradient
          id="aT"
          x1={879.88}
          y1={817.03}
          x2={885.47}
          y2={817.03}
          xlinkHref="#b"
        />
        <LinearGradient
          id="aU"
          x1={880.78}
          y1={822.96}
          x2={890.01}
          y2={822.96}
          xlinkHref="#b"
        />
        <LinearGradient
          id="aV"
          x1={584.63}
          y1={626.98}
          x2={872.86}
          y2={626.98}
          xlinkHref="#b"
        />
        <LinearGradient
          id="aW"
          x1={548.07}
          y1={447.42}
          x2={556.31}
          y2={447.42}
          xlinkHref="#b"
        />
        <LinearGradient
          id="aX"
          x1={581.11}
          y1={473.64}
          x2={585.77}
          y2={473.64}
          xlinkHref="#b"
        />
        <LinearGradient
          id="aY"
          x1={577.74}
          y1={469.31}
          x2={580.46}
          y2={469.31}
          xlinkHref="#b"
        />
        <LinearGradient
          id="aZ"
          x1={579.21}
          y1={471.17}
          x2={582.71}
          y2={471.17}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ba"
          x1={576.31}
          y1={468.62}
          x2={579.72}
          y2={468.62}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bb"
          x1={552.3}
          y1={618.38}
          x2={873.29}
          y2={618.38}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bc"
          x1={581.25}
          y1={475.65}
          x2={585.82}
          y2={475.65}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bd"
          x1={577.79}
          y1={471.3}
          x2={580.51}
          y2={471.3}
          xlinkHref="#b"
        />
        <LinearGradient
          id="be"
          x1={579.25}
          y1={473.24}
          x2={583.1}
          y2={473.24}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bf"
          x1={574.62}
          y1={465.7}
          x2={576.58}
          y2={465.7}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bg"
          x1={575.18}
          y1={470.33}
          x2={580.8}
          y2={470.33}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bh"
          x1={571.87}
          y1={466.47}
          x2={577.07}
          y2={466.47}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bi"
          x1={575.48}
          y1={469.82}
          x2={578.55}
          y2={469.82}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bj"
          x1={569.1}
          y1={463.27}
          x2={573.97}
          y2={463.27}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bk"
          x1={571.25}
          y1={466.08}
          x2={576.86}
          y2={466.08}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bl"
          x1={553.64}
          y1={454}
          x2={565.16}
          y2={454}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bm"
          x1={578.59}
          y1={473.16}
          x2={580.51}
          y2={473.16}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bn"
          x1={579.37}
          y1={473.47}
          x2={580.84}
          y2={473.47}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bo"
          x1={575.3}
          y1={471.01}
          x2={580.71}
          y2={471.01}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bp"
          x1={571.51}
          y1={466.73}
          x2={577.2}
          y2={466.73}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bq"
          x1={575.46}
          y1={470.24}
          x2={578.85}
          y2={470.24}
          xlinkHref="#b"
        />
        <LinearGradient
          id="br"
          x1={569.79}
          y1={463.64}
          x2={573.55}
          y2={463.64}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bs"
          x1={570.84}
          y1={465.33}
          x2={576.53}
          y2={465.33}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bt"
          x1={558.36}
          y1={457.19}
          x2={567.83}
          y2={457.19}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bu"
          x1={575.52}
          y1={471.7}
          x2={578.81}
          y2={471.7}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bv"
          x1={562.76}
          y1={460.39}
          x2={570.81}
          y2={460.39}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bw"
          x1={566.99}
          y1={463.6}
          x2={573.96}
          y2={463.6}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bx"
          x1={570.7}
          y1={466.27}
          x2={577.89}
          y2={466.27}
          xlinkHref="#b"
        />
        <LinearGradient
          id="by"
          x1={868.89}
          y1={785.59}
          x2={873.22}
          y2={785.59}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bz"
          x1={584.44}
          y1={621.73}
          x2={874.24}
          y2={621.73}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bA"
          x1={585.65}
          y1={617.66}
          x2={872.99}
          y2={617.66}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bB"
          x1={539.65}
          y1={440.59}
          x2={548.8}
          y2={440.59}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bC"
          x1={580.43}
          y1={468.49}
          x2={585.75}
          y2={468.49}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bD"
          x1={576.55}
          y1={464.57}
          x2={580.31}
          y2={464.57}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bE"
          x1={578.92}
          y1={466.3}
          x2={582.21}
          y2={466.3}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bF"
          x1={572.88}
          y1={461.31}
          x2={576.15}
          y2={461.31}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bG"
          x1={574.44}
          y1={463.09}
          x2={578.75}
          y2={463.09}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bH"
          x1={572.03}
          y1={460.89}
          x2={575.38}
          y2={460.89}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bI"
          x1={881.14}
          y1={824.49}
          x2={883.87}
          y2={824.49}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bJ"
          x1={880.08}
          y1={824.17}
          x2={886.49}
          y2={824.17}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bK"
          x1={879.45}
          y1={822.03}
          x2={885.19}
          y2={822.03}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bL"
          x1={878.75}
          y1={819.94}
          x2={884.01}
          y2={819.94}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bM"
          x1={877.73}
          y1={817.42}
          x2={883.06}
          y2={817.42}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bN"
          x1={876.72}
          y1={813.19}
          x2={887.65}
          y2={813.19}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bO"
          x1={881.23}
          y1={824.76}
          x2={886.92}
          y2={824.76}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bP"
          x1={879.49}
          y1={822.42}
          x2={886.17}
          y2={822.42}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bQ"
          x1={877.63}
          y1={820.58}
          x2={886.8}
          y2={820.58}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bR"
          x1={878.24}
          y1={817.43}
          x2={882.55}
          y2={817.43}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bS"
          x1={877.89}
          y1={815.62}
          x2={881.17}
          y2={815.62}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bT"
          x1={876.72}
          y1={803.95}
          x2={879.85}
          y2={803.95}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bU"
          x1={880.55}
          y1={821.68}
          x2={884.79}
          y2={821.68}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bV"
          x1={881.64}
          y1={822.72}
          x2={885.58}
          y2={822.72}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bW"
          x1={880.25}
          y1={821.31}
          x2={885.25}
          y2={821.31}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bX"
          x1={876.69}
          y1={806.78}
          x2={880.47}
          y2={806.78}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bY"
          x1={876.87}
          y1={809.67}
          x2={881.21}
          y2={809.67}
          xlinkHref="#b"
        />
        <LinearGradient
          id="bZ"
          x1={877.24}
          y1={812.56}
          x2={882.04}
          y2={812.56}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ca"
          x1={877.8}
          y1={815.39}
          x2={882.96}
          y2={815.39}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cb"
          x1={544.29}
          y1={463.65}
          x2={602.04}
          y2={463.65}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cc"
          x1={580.74}
          y1={470.63}
          x2={585.77}
          y2={470.63}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cd"
          x1={576.86}
          y1={466.62}
          x2={580.42}
          y2={466.62}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ce"
          x1={579.04}
          y1={468.5}
          x2={582.49}
          y2={468.5}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cf"
          x1={572.91}
          y1={463.28}
          x2={576.68}
          y2={463.28}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cg"
          x1={574.53}
          y1={465.13}
          x2={579.46}
          y2={465.13}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ch"
          x1={569.45}
          y1={457.64}
          x2={571.44}
          y2={457.64}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ci"
          x1={569.96}
          y1={462.39}
          x2={576.88}
          y2={462.39}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cj"
          x1={566.57}
          y1={458.75}
          x2={572.62}
          y2={458.75}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ck"
          x1={570.37}
          y1={461.51}
          x2={574.3}
          y2={461.51}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cl"
          x1={563.62}
          y1={457.61}
          x2={572.38}
          y2={457.61}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cm"
          x1={545.83}
          y1={447.04}
          x2={559.58}
          y2={447.04}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cn"
          x1={574.2}
          y1={465.23}
          x2={576.65}
          y2={465.23}
          xlinkHref="#b"
        />
        <LinearGradient
          id="co"
          x1={575.07}
          y1={465.6}
          x2={577.12}
          y2={465.6}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cp"
          x1={570.42}
          y1={463.12}
          x2={576.82}
          y2={463.12}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cq"
          x1={566}
          y1={459.08}
          x2={572.99}
          y2={459.08}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cr"
          x1={570.41}
          y1={462.28}
          x2={574.77}
          y2={462.28}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cs"
          x1={564.3}
          y1={457.75}
          x2={571.92}
          y2={457.75}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ct"
          x1={551.23}
          y1={450.03}
          x2={562.48}
          y2={450.03}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cu"
          x1={570.97}
          y1={463.92}
          x2={574.96}
          y2={463.92}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cv"
          x1={556.1}
          y1={453.03}
          x2={565.81}
          y2={453.03}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cw"
          x1={560.8}
          y1={456.06}
          x2={569.33}
          y2={456.06}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cx"
          x1={565.41}
          y1={459.45}
          x2={573.78}
          y2={459.45}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cy"
          x1={866.45}
          y1={766.04}
          x2={874.24}
          y2={766.04}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cz"
          x1={870.78}
          y1={780.49}
          x2={873.99}
          y2={780.49}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cA"
          x1={871.85}
          y1={788.47}
          x2={873.51}
          y2={788.47}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cB"
          x1={584.09}
          y1={616.45}
          x2={876.87}
          y2={616.45}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cC"
          x1={532.29}
          y1={434.87}
          x2={540.31}
          y2={434.87}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cD"
          x1={579.6}
          y1={463.25}
          x2={585.58}
          y2={463.25}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cE"
          x1={575.22}
          y1={459.68}
          x2={580.04}
          y2={459.68}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cF"
          x1={578.47}
          y1={461.29}
          x2={581.58}
          y2={461.29}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cG"
          x1={571.03}
          y1={456.58}
          x2={575.47}
          y2={456.58}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cH"
          x1={573.55}
          y1={458.2}
          x2={577.63}
          y2={458.2}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cI"
          x1={567.11}
          y1={453.47}
          x2={570.71}
          y2={453.47}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cJ"
          x1={568.64}
          y1={455.22}
          x2={573.78}
          y2={455.22}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cK"
          x1={567.38}
          y1={453.48}
          x2={570.01}
          y2={453.48}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cL"
          x1={536.43}
          y1={456.99}
          x2={601.17}
          y2={456.99}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cM"
          x1={580.06}
          y1={465.47}
          x2={585.65}
          y2={465.47}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cN"
          x1={575.75}
          y1={461.81}
          x2={580.19}
          y2={461.81}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cO"
          x1={578.71}
          y1={463.6}
          x2={581.87}
          y2={463.6}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cP"
          x1={571.39}
          y1={458.58}
          x2={575.97}
          y2={458.58}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cQ"
          x1={573.83}
          y1={460.38}
          x2={578.3}
          y2={460.38}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cR"
          x1={566.93}
          y1={455.28}
          x2={571.77}
          y2={455.28}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cS"
          x1={568.68}
          y1={457.15}
          x2={575.01}
          y2={457.15}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cT"
          x1={563.5}
          y1={454.61}
          x2={572.18}
          y2={454.61}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cU"
          x1={560.48}
          y1={451.28}
          x2={567.05}
          y2={451.28}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cV"
          x1={563.71}
          y1={453.3}
          x2={569.31}
          y2={453.3}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cW"
          x1={557.75}
          y1={448.49}
          x2={563.72}
          y2={448.49}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cX"
          x1={870.38}
          y1={760.61}
          x2={876.45}
          y2={760.61}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cY"
          x1={537.23}
          y1={440.51}
          x2={552.93}
          y2={440.51}
          xlinkHref="#b"
        />
        <LinearGradient
          id="cZ"
          x1={568.81}
          y1={457.34}
          x2={571.79}
          y2={457.34}
          xlinkHref="#b"
        />
        <LinearGradient
          id="da"
          x1={569.66}
          y1={457.85}
          x2={572.78}
          y2={457.85}
          xlinkHref="#b"
        />
        <LinearGradient
          id="db"
          x1={564.41}
          y1={455.34}
          x2={572.15}
          y2={455.34}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dc"
          x1={562.82}
          y1={453.89}
          x2={568.03}
          y2={453.89}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dd"
          x1={564.2}
          y1={454.46}
          x2={569.92}
          y2={454.46}
          xlinkHref="#b"
        />
        <LinearGradient
          id="de"
          x1={558.28}
          y1={450.59}
          x2={566.46}
          y2={450.59}
          xlinkHref="#b"
        />
        <LinearGradient
          id="df"
          x1={565.57}
          y1={456.53}
          x2={568.5}
          y2={456.53}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dg"
          x1={564.75}
          y1={455.36}
          x2={570.33}
          y2={455.36}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dh"
          x1={548.61}
          y1={446.03}
          x2={559.78}
          y2={446.03}
          xlinkHref="#b"
        />
        <LinearGradient
          id="di"
          x1={553.77}
          y1={448.85}
          x2={563.67}
          y2={448.85}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dj"
          x1={558.77}
          y1={451.66}
          x2={567.64}
          y2={451.66}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dk"
          x1={564.36}
          y1={454.37}
          x2={568.94}
          y2={454.37}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dl"
          x1={872.87}
          y1={775.89}
          x2={875.37}
          y2={775.89}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dm"
          x1={872.59}
          y1={782.53}
          x2={874.39}
          y2={782.53}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dn"
          x1={877.01}
          y1={821.32}
          x2={881.41}
          y2={821.32}
          xlinkHref="#b"
        />
        <LinearGradient
          id="do"
          x1={876.3}
          y1={818.61}
          x2={880.22}
          y2={818.61}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dp"
          x1={876.44}
          y1={817.3}
          x2={879.09}
          y2={817.3}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dq"
          x1={877.54}
          y1={822.17}
          x2={883.28}
          y2={822.17}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dr"
          x1={876.26}
          y1={819.54}
          x2={882.7}
          y2={819.54}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ds"
          x1={875.93}
          y1={817.14}
          x2={881.52}
          y2={817.14}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dt"
          x1={875.6}
          y1={813.35}
          x2={879.14}
          y2={813.35}
          xlinkHref="#b"
        />
        <LinearGradient
          id="du"
          x1={876.02}
          y1={816.34}
          x2={880.45}
          y2={816.34}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dv"
          x1={875.09}
          y1={809.49}
          x2={877.69}
          y2={809.49}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dw"
          x1={875.61}
          y1={813.92}
          x2={879.6}
          y2={813.92}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dx"
          x1={875.94}
          y1={796.45}
          x2={878.14}
          y2={796.45}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dy"
          x1={879.47}
          y1={821.68}
          x2={882.17}
          y2={821.68}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dz"
          x1={878.01}
          y1={820.32}
          x2={882.51}
          y2={820.32}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dA"
          x1={876.56}
          y1={817.63}
          x2={881.72}
          y2={817.63}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dB"
          x1={875.04}
          y1={813.57}
          x2={881}
          y2={813.57}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dC"
          x1={876.68}
          y1={817.01}
          x2={881.29}
          y2={817.01}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dD"
          x1={875.41}
          y1={811}
          x2={878.67}
          y2={811}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dE"
          x1={875.27}
          y1={813.51}
          x2={880.3}
          y2={813.51}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dF"
          x1={876.43}
          y1={814.87}
          x2={879.51}
          y2={814.87}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dG"
          x1={875.22}
          y1={810.07}
          x2={878.51}
          y2={810.07}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dH"
          x1={874.85}
          y1={811.45}
          x2={878.15}
          y2={811.45}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dI"
          x1={875.54}
          y1={798.99}
          x2={877.98}
          y2={798.99}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dJ"
          x1={878.53}
          y1={819.27}
          x2={881.98}
          y2={819.27}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dK"
          x1={877.16}
          y1={815.36}
          x2={881.04}
          y2={815.36}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dL"
          x1={877.39}
          y1={816.87}
          x2={881.02}
          y2={816.87}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dM"
          x1={875.31}
          y1={801.68}
          x2={878.05}
          y2={801.68}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dN"
          x1={875.27}
          y1={804.67}
          x2={878.42}
          y2={804.67}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dO"
          x1={875.25}
          y1={807.63}
          x2={878.94}
          y2={807.63}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dP"
          x1={875.34}
          y1={810.68}
          x2={879.59}
          y2={810.68}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dQ"
          x1={875.53}
          y1={813.65}
          x2={880.34}
          y2={813.65}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dR"
          x1={877.48}
          y1={817.06}
          x2={881.09}
          y2={817.06}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dS"
          x1={583.39}
          y1={621.06}
          x2={882.14}
          y2={621.06}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dT"
          x1={584.76}
          y1={617.35}
          x2={881.03}
          y2={617.35}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dU"
          x1={578.19}
          y1={456.95}
          x2={585.26}
          y2={456.95}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dV"
          x1={573}
          y1={453.43}
          x2={579.61}
          y2={453.43}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dW"
          x1={577.58}
          y1={455.2}
          x2={580.78}
          y2={455.2}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dX"
          x1={567.83}
          y1={450.2}
          x2={574.63}
          y2={450.2}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dY"
          x1={571.9}
          y1={451.97}
          x2={576.35}
          y2={451.97}
          xlinkHref="#b"
        />
        <LinearGradient
          id="dZ"
          x1={562.66}
          y1={446.94}
          x2={569.51}
          y2={446.94}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ea"
          x1={566.1}
          y1={448.79}
          x2={572}
          y2={448.79}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eb"
          x1={557.43}
          y1={443.61}
          x2={564.23}
          y2={443.61}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ec"
          x1={560.08}
          y1={445.59}
          x2={567.74}
          y2={445.59}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ed"
          x1={552.04}
          y1={439.17}
          x2={557.25}
          y2={439.17}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ee"
          x1={553.76}
          y1={442.35}
          x2={563.63}
          y2={442.35}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ef"
          x1={546.29}
          y1={438.49}
          x2={558.66}
          y2={438.49}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eg"
          x1={556.32}
          y1={442.95}
          x2={559.76}
          y2={442.95}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eh"
          x1={540.19}
          y1={434.66}
          x2={552.47}
          y2={434.66}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ei"
          x1={546.79}
          y1={437.85}
          x2={556.35}
          y2={437.85}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ej"
          x1={539.23}
          y1={432.81}
          x2={548.19}
          y2={432.81}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ek"
          x1={539.08}
          y1={431.09}
          x2={543.29}
          y2={431.09}
          xlinkHref="#b"
        />
        <LinearGradient
          id="el"
          x1={870.68}
          y1={817.02}
          x2={875.92}
          y2={817.02}
          xlinkHref="#b"
        />
        <LinearGradient
          id="em"
          x1={870.25}
          y1={813.65}
          x2={875}
          y2={813.65}
          xlinkHref="#b"
        />
        <LinearGradient
          id="en"
          x1={870.01}
          y1={809.35}
          x2={873.82}
          y2={809.35}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eo"
          x1={870.25}
          y1={812.04}
          x2={874.17}
          y2={812.04}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ep"
          x1={870}
          y1={805.71}
          x2={873.18}
          y2={805.71}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eq"
          x1={870.02}
          y1={808.53}
          x2={873.5}
          y2={808.53}
          xlinkHref="#b"
        />
        <LinearGradient
          id="er"
          x1={870}
          y1={802.12}
          x2={872.74}
          y2={802.12}
          xlinkHref="#b"
        />
        <LinearGradient
          id="es"
          x1={870}
          y1={804.95}
          x2={872.99}
          y2={804.95}
          xlinkHref="#b"
        />
        <LinearGradient
          id="et"
          x1={870.25}
          y1={798.53}
          x2={872.64}
          y2={798.53}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eu"
          x1={870.16}
          y1={801.45}
          x2={872.66}
          y2={801.45}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ev"
          x1={870.76}
          y1={795.7}
          x2={873.63}
          y2={795.7}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ew"
          x1={870.47}
          y1={798.07}
          x2={872.81}
          y2={798.07}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ex"
          x1={871.49}
          y1={791.74}
          x2={873.23}
          y2={791.74}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ey"
          x1={870.99}
          y1={794.17}
          x2={873.06}
          y2={794.17}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ez"
          x1={870.76}
          y1={796.8}
          x2={872.83}
          y2={796.8}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eA"
          x1={871.55}
          y1={789.44}
          x2={873.31}
          y2={789.44}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eB"
          x1={871.1}
          y1={793.53}
          x2={873.21}
          y2={793.53}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eC"
          x1={872.35}
          y1={788.32}
          x2={873.7}
          y2={788.32}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eD"
          x1={872.11}
          y1={788.53}
          x2={873.6}
          y2={788.53}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eE"
          x1={583.95}
          y1={466.11}
          x2={599.98}
          y2={466.11}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eF"
          x1={579.21}
          y1={460.19}
          x2={585.36}
          y2={460.19}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eG"
          x1={574.45}
          y1={456.86}
          x2={579.8}
          y2={456.86}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eH"
          x1={578.23}
          y1={458.56}
          x2={581.1}
          y2={458.56}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eI"
          x1={569.67}
          y1={453.79}
          x2={575.12}
          y2={453.79}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eJ"
          x1={572.95}
          y1={455.49}
          x2={577}
          y2={455.49}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eK"
          x1={564.83}
          y1={450.73}
          x2={570.48}
          y2={450.73}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eL"
          x1={567.47}
          y1={452.44}
          x2={573.16}
          y2={452.44}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eM"
          x1={559.9}
          y1={447.45}
          x2={565.73}
          y2={447.45}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eN"
          x1={561.69}
          y1={449.42}
          x2={569.64}
          y2={449.42}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eO"
          x1={554.8}
          y1={446.05}
          x2={566.48}
          y2={446.05}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eP"
          x1={549.18}
          y1={441.68}
          x2={560.36}
          y2={441.68}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eQ"
          x1={555.47}
          y1={445.03}
          x2={563.38}
          y2={445.03}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eR"
          x1={547.46}
          y1={437.72}
          x2={552.22}
          y2={437.72}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eS"
          x1={548.49}
          y1={439.7}
          x2={556.67}
          y2={439.7}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eT"
          x1={542.63}
          y1={436.14}
          x2={552.13}
          y2={436.14}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eU"
          x1={562.22}
          y1={448.71}
          x2={565.01}
          y2={448.71}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eV"
          x1={563.12}
          y1={450.49}
          x2={568.06}
          y2={450.49}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eW"
          x1={557.38}
          y1={447.71}
          x2={565.95}
          y2={447.71}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eX"
          x1={563.98}
          y1={451.07}
          x2={566.67}
          y2={451.07}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eY"
          x1={555.86}
          y1={446.79}
          x2={562.21}
          y2={446.79}
          xlinkHref="#b"
        />
        <LinearGradient
          id="eZ"
          x1={556.83}
          y1={447.06}
          x2={564.45}
          y2={447.06}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fa"
          x1={551.37}
          y1={439.62}
          x2={553.11}
          y2={439.62}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fb"
          x1={551.4}
          y1={444.35}
          x2={561.44}
          y2={444.35}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fc"
          x1={557.41}
          y1={445.58}
          x2={560.1}
          y2={445.58}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fd"
          x1={559.23}
          y1={449.15}
          x2={565.29}
          y2={449.15}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fe"
          x1={539.9}
          y1={438.5}
          x2={557.17}
          y2={438.5}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ff"
          x1={548.66}
          y1={442.72}
          x2={561.5}
          y2={442.72}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fg"
          x1={557.72}
          y1={447.62}
          x2={563.52}
          y2={447.62}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fh"
          x1={873.09}
          y1={818.9}
          x2={878.73}
          y2={818.9}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fi"
          x1={872.36}
          y1={815.71}
          x2={877.65}
          y2={815.71}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fj"
          x1={871.81}
          y1={811.08}
          x2={875.84}
          y2={811.08}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fk"
          x1={872.24}
          y1={813.87}
          x2={876.64}
          y2={813.87}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fl"
          x1={871.48}
          y1={807.51}
          x2={874.95}
          y2={807.51}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fm"
          x1={871.73}
          y1={810.53}
          x2={875.74}
          y2={810.53}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fn"
          x1={871.4}
          y1={803.83}
          x2={874.21}
          y2={803.83}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fo"
          x1={871.46}
          y1={807.11}
          x2={874.97}
          y2={807.11}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fp"
          x1={871.46}
          y1={800.78}
          x2={874.55}
          y2={800.78}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fq"
          x1={871.45}
          y1={803.74}
          x2={874.34}
          y2={803.74}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fr"
          x1={871.52}
          y1={798.37}
          x2={873.68}
          y2={798.37}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fs"
          x1={871.01}
          y1={802.14}
          x2={873.87}
          y2={802.14}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ft"
          x1={871.7}
          y1={794.5}
          x2={873.46}
          y2={794.5}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fu"
          x1={871.7}
          y1={799.41}
          x2={873.54}
          y2={799.41}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fv"
          x1={872.07}
          y1={793.27}
          x2={873.42}
          y2={793.27}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fw"
          x1={871.94}
          y1={793.71}
          x2={873.43}
          y2={793.71}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fx"
          x1={874.24}
          y1={795.91}
          x2={882.23}
          y2={795.91}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fy"
          x1={875.37}
          y1={820.1}
          x2={879.66}
          y2={820.1}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fz"
          x1={874.38}
          y1={817.18}
          x2={878.9}
          y2={817.18}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fA"
          x1={873.54}
          y1={813.31}
          x2={879.52}
          y2={813.31}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fB"
          x1={874.01}
          y1={815.26}
          x2={878.32}
          y2={815.26}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fC"
          x1={872.87}
          y1={809.58}
          x2={877.6}
          y2={809.58}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fD"
          x1={873.23}
          y1={811.84}
          x2={877.63}
          y2={811.84}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fE"
          x1={873.45}
          y1={814.1}
          x2={878}
          y2={814.1}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fF"
          x1={872.43}
          y1={805.61}
          x2={875.88}
          y2={805.61}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fG"
          x1={872.65}
          y1={808.16}
          x2={876.48}
          y2={808.16}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fH"
          x1={872.44}
          y1={810.94}
          x2={877.14}
          y2={810.94}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fI"
          x1={872.21}
          y1={803.44}
          x2={875.42}
          y2={803.44}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fJ"
          x1={871.58}
          y1={807.65}
          x2={876.36}
          y2={807.65}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fK"
          x1={872.26}
          y1={799.48}
          x2={874.54}
          y2={799.48}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fL"
          x1={872.35}
          y1={802.51}
          x2={874.61}
          y2={802.51}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fM"
          x1={872.32}
          y1={798.32}
          x2={873.94}
          y2={798.32}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fN"
          x1={872.32}
          y1={798.82}
          x2={874.12}
          y2={798.82}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fO"
          x1={873.24}
          y1={784.82}
          x2={878.05}
          y2={784.82}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fP"
          x1={875.14}
          y1={813.64}
          x2={877.53}
          y2={813.64}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fQ"
          x1={874.09}
          y1={811.73}
          x2={877.57}
          y2={811.73}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fR"
          x1={875.55}
          y1={814.68}
          x2={877.73}
          y2={814.68}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fS"
          x1={873.17}
          y1={808.17}
          x2={877.07}
          y2={808.17}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fT"
          x1={874.45}
          y1={811.9}
          x2={877.39}
          y2={811.9}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fU"
          x1={873.53}
          y1={807.03}
          x2={876.58}
          y2={807.03}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fV"
          x1={873.53}
          y1={807.97}
          x2={876.72}
          y2={807.97}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fW"
          x1={873.02}
          y1={803.25}
          x2={874.98}
          y2={803.25}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fX"
          x1={872.84}
          y1={804.95}
          x2={876.29}
          y2={804.95}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fY"
          x1={873.58}
          y1={806.45}
          x2={875.72}
          y2={806.45}
          xlinkHref="#b"
        />
        <LinearGradient
          id="fZ"
          x1={872.48}
          y1={789.5}
          x2={877.55}
          y2={789.5}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ga"
          x1={875.68}
          y1={813.02}
          x2={877.4}
          y2={813.02}
          xlinkHref="#b"
        />
        <LinearGradient
          id="gb"
          x1={874.66}
          y1={810.48}
          x2={877.18}
          y2={810.48}
          xlinkHref="#b"
        />
        <LinearGradient
          id="gc"
          x1={872.2}
          y1={793.29}
          x2={877.09}
          y2={793.29}
          xlinkHref="#b"
        />
        <LinearGradient
          id="gd"
          x1={872.19}
          y1={797.12}
          x2={876.68}
          y2={797.12}
          xlinkHref="#b"
        />
        <LinearGradient
          id="ge"
          x1={872.18}
          y1={801.11}
          x2={876.45}
          y2={801.11}
          xlinkHref="#b"
        />
        <LinearGradient
          id="gf"
          x1={872.66}
          y1={805.03}
          x2={876.69}
          y2={805.03}
          xlinkHref="#b"
        />
        <LinearGradient
          id="gg"
          x1={873.91}
          y1={809.47}
          x2={877.13}
          y2={809.47}
          xlinkHref="#b"
        />
      </Defs>
      <Path
        d="M797.54 583.24c86.88 64.28 112.96 114.86 95.57 176.03-.02.08-.05.16-.07.24.09 3.91-.66 7.68-2.07 11.17-.15 1.99-.36 3.98-.65 5.95 28.09-10.49 66.18-28.1 92.46-40.13 21.52-9.85 33.62-18.61 46.55-31.68-217.72-115.74-231.79-121.59-231.79-121.59z"
        fill="url(#a)"
      />
      <Path
        d="M583.82 584.14c-2.6-5.68-5-11.46-7.17-17.32-6.33-17.06-12.78-36.84-13.28-55.19-.17-5.97 5.9-33.19-4.71-33.41-2.83-.06-5.65-.09-8.48-.07-54.64.36-97.32 18.13-141.4 51.66-.8.61-1.61 1.22-2.41 1.83 54.87 32.36 109.77 64.69 164.7 96.95 31.55 18.53 39.19 21.86 70.79 40.31.76.44 1.5.88 2.33 1.02-1.27-2.6-4.07-4.83-6.09-6.94-22.18-23.11-40.93-49.71-54.27-78.85z"
        fill="url(#c)"
      />
      <Path
        d="M872.87 818.94l-1.09-.65-2.8-1.84c-16.44-10.85-33.03-22.05-49.07-32.88-11.57-7.81-23.53-15.88-35.33-23.75-18.36-12.26-39.65-26.6-60.13-41.74-9.7-7.12-19.47-14.72-29.03-22.58-10.46-8.6-19.51-16.61-27.69-24.5l-2.45-2.32-7.19-7.19c-1.03-1.05-2.03-2.11-3.03-3.18-.55-.58-1.1-1.17-1.65-1.75-.54-.59-1.09-1.16-1.63-1.73-1-1.05-2.04-2.14-3.01-3.27-.81-.92-1.62-1.84-2.44-2.76-2.16-2.43-4.4-4.95-6.48-7.55l-4.33-5.26-4.18-5.44a258.169 258.169 0 01-28.67-47.02c-7.75-16.27-13.69-34.03-17.63-52.78-1.82-8.66-3.22-17.64-4.16-26.7l1.09-.19c.65 3.17 1.36 6.37 2.12 9.5 3.3 13.73 7.66 27.15 12.94 39.89.85 2.05 1.74 4.13 2.65 6.18 2.57 7.28 5.5 14.37 8.71 21.1a250.7 250.7 0 0027.93 45.79l4.08 5.32 4.25 5.15c2.02 2.52 4.2 4.97 6.3 7.34.82.92 1.64 1.84 2.45 2.77.94 1.1 1.96 2.17 2.94 3.2.53.56 1.07 1.12 1.59 1.69.54.57 1.08 1.15 1.62 1.72.98 1.04 1.96 2.09 2.97 3.11l7.81 7.78 1.67 1.59c8.07 7.78 17 15.68 27.33 24.17 9.47 7.78 19.15 15.31 28.77 22.37 20.41 15.08 41.61 29.35 59.87 41.55 11.86 7.92 23.86 16.01 35.46 23.84 7.24 4.89 14.48 9.77 21.73 14.64l6.99 5.62c6.42 5.16 13.06 10.5 19.63 15.71l.18.14.04.23c.18 1.1.38 2.2.59 3.29l.27 1.35z"
        fill="url(#b)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M583.4 515.28c.76 5.15 1.67 10.25 2.72 15.24 3.92 18.65 9.82 36.32 17.54 52.5a257.237 257.237 0 0028.54 46.8l4.16 5.42 4.32 5.24c2.07 2.58 4.3 5.09 6.45 7.51.82.92 1.64 1.84 2.45 2.77.95 1.11 1.98 2.19 2.97 3.23.55.58 1.1 1.15 1.64 1.74.55.58 1.1 1.16 1.65 1.75.99 1.06 1.99 2.12 3.01 3.16l9.62 9.49c8.16 7.87 17.2 15.86 27.63 24.44 9.55 7.84 19.3 15.43 28.99 22.54 20.47 15.12 41.74 29.45 60.07 41.69 11.82 7.89 23.78 15.96 35.35 23.77 16.04 10.83 32.63 22.02 49.07 32.87l1.7 1.12c-.11-.61-.22-1.23-.32-1.84-6.51-5.17-13.09-10.46-19.45-15.58l-6.96-5.59c-7.21-4.84-14.45-9.73-21.7-14.62-11.6-7.83-23.6-15.93-35.44-23.83-18.29-12.22-39.5-26.5-59.93-41.59a680.651 680.651 0 01-28.81-22.41c-10.35-8.51-19.31-16.43-27.39-24.23l-2.42-2.3-7.09-7.09c-1.01-1.03-2-2.08-2.99-3.13-.54-.58-1.08-1.15-1.62-1.72-.53-.57-1.06-1.13-1.59-1.68-.99-1.04-2.02-2.12-2.98-3.24-.81-.92-1.62-1.84-2.44-2.76-2.12-2.38-4.3-4.84-6.34-7.38l-4.26-5.16-4.1-5.34a252.189 252.189 0 01-28.06-46.01c-3.23-6.77-6.17-13.9-8.74-21.17-.9-2.02-1.79-4.1-2.65-6.16-5.1-12.3-9.34-25.23-12.6-38.46z"
        fill="url(#d)"
      />
      <Path
        d="M583.5 515.77c1.54 6.48 2.72 12.72 4.13 19.23 2.51 10.91 5.73 21.65 9.75 32.1 19.27 50.57 56.36 92 97.68 125.97 48.16 39.92 124.35 87.24 176.49 123.08l-.77.51-.32-1.83v-.02l.18.31-26.62-20.91c-11.73-7.69-24-15.95-35.92-23.84-81.92-54.83-176.16-112.55-210.2-210.13a267.358 267.358 0 01-13.54-39.1l-.74-2.86c-.37-1.06-.06-1.42-.12-2.5zm-.19-.98c1.01 1.56 1.61 4.27 2.1 6.06 1.57 5.68 3.33 11.3 5.27 16.86 2.57 7.42 5.52 14.69 8.73 21.86 4.87 13.51 11.09 26.51 18.26 38.95 14.37 24.83 33.19 46.93 53.79 66.77 36.29 34.73 78.49 63.08 120.04 91.09 17.22 11.72 36.47 24.75 53.55 36.51.02.02 26.2 21.42 26.22 21.43l.15.12.03.19v.02l.32 1.81.2 1.16-.97-.65c-42.88-29.33-115.01-75.58-155.48-106.4-35.63-27.15-69.41-57.79-94.31-95.33-19.8-30.11-33.87-64.5-37.91-100.46z"
        fill="#40a840"
      />
      <Path
        d="M574.92 450.98l-2.65-1.57-.06-.24c-1.35-5.6-2.99-11.06-4.89-16.23l1.03-.45a175.26 175.26 0 016.14 17.08l.43 1.42z"
        fill="url(#e)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M869.04 806.24c-4.82-3.85-9.63-7.71-14.44-11.58l-7.35-5.91c-3.14-3-6.25-5.96-9.38-8.9-14.81-13.92-28.24-25.66-41.05-35.88-13.74-10.94-27.9-21.8-41.59-32.31-7.28-5.59-14.57-11.18-21.83-16.81-11.46-8.87-21.76-17.07-31.48-25.07-4.96-4.05-9.92-8.29-14.71-12.39l-.72-.62-7.57-6.71a206.49 206.49 0 01-4.84-4.42c-.87-.81-1.75-1.63-2.63-2.43-2.36-2.14-4.67-4.41-6.92-6.6l-1.11-1.08c-1.89-1.83-3.84-3.73-5.68-5.69-.77-.81-1.56-1.62-2.35-2.42-1.42-1.46-2.89-2.97-4.29-4.51l-6.45-7.13-6.61-7.82-6.37-8.01-6.13-8.22-5.88-8.43c-7.22-10.72-13.74-21.86-19.4-33.13a263.95 263.95 0 01-11.07-33.47l1.03-.42c3.74 7.91 7.79 15.72 12.04 23.22.8 1.7 1.59 3.35 2.39 4.99 5.82 11.89 12.62 23.64 20.2 34.9l6.33 9.01 5.44 7.29 6.24 7.85 6.47 7.65 6.33 7.01c1.35 1.5 2.79 2.97 4.18 4.4.78.8 1.56 1.6 2.33 2.41 1.77 1.88 3.66 3.71 5.48 5.48l1.19 1.16c2.19 2.15 4.46 4.37 6.81 6.5.88.81 1.76 1.62 2.64 2.44 1.54 1.44 3.13 2.92 4.74 4.33l8.28 7.31c4.73 4.05 9.62 8.23 14.52 12.23 9.67 7.96 19.92 16.12 31.33 24.95 7.26 5.63 14.56 11.23 21.86 16.83 13.69 10.51 27.84 21.37 41.61 32.33 12.96 10.34 26.51 22.19 41.46 36.24 2.75 2.58 5.49 5.18 8.22 7.79 5.87 6.72 11.72 13.63 17.37 20.31l2.08 2.45-.75.86z"
        fill="url(#f)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M591.86 522.21c2.65 9.39 5.82 18.61 9.43 27.47 5.61 11.18 12.11 22.28 19.29 32.95l5.86 8.4 6.11 8.19 6.35 7.98 6.57 7.77 6.45 7.13c1.38 1.53 2.84 3.03 4.26 4.48.79.81 1.58 1.62 2.36 2.44 1.83 1.94 3.77 3.83 5.65 5.65l1.11 1.08c2.24 2.19 4.55 4.45 6.89 6.58.88.81 1.76 1.63 2.64 2.44 1.57 1.46 3.19 2.97 4.82 4.4l8.28 7.31c4.79 4.1 9.74 8.33 14.69 12.38 9.72 7.99 20 16.19 31.45 25.05 7.26 5.63 14.54 11.22 21.82 16.81 13.69 10.51 27.86 21.38 41.59 32.31 12.85 10.26 26.3 22.02 41.14 35.96 3.13 2.94 6.25 5.9 9.35 8.87l7.31 5.87c3.29 2.64 6.57 5.29 9.86 7.92-5.1-6.03-10.35-12.2-15.58-18.2-2.69-2.57-5.43-5.17-8.18-7.75-14.93-14.02-28.46-25.85-41.38-36.16-13.77-10.97-27.92-21.83-41.61-32.33-7.3-5.6-14.6-11.2-21.86-16.84-11.42-8.84-21.68-17-31.36-24.97-4.91-4.01-9.8-8.2-14.54-12.25l-.78-.67-7.51-6.65c-1.62-1.42-3.22-2.91-4.76-4.35-.87-.81-1.75-1.63-2.63-2.43-2.37-2.15-4.64-4.37-6.84-6.53l-1.19-1.16c-1.83-1.78-3.72-3.62-5.51-5.52-.77-.8-1.54-1.6-2.32-2.4-1.4-1.43-2.84-2.92-4.21-4.43l-6.33-7-6.5-7.7-6.27-7.88-6.03-8.08-5.77-8.28c-7.62-11.32-14.45-23.11-20.29-35.05-.81-1.65-1.6-3.31-2.38-4.97-3.28-5.78-6.45-11.77-9.45-17.86z"
        fill="url(#g)"
      />
      <Path
        d="M579.37 496.18c-.75-2.62-1.47-5.28-2.15-7.9l1.05-.37c.48 1.27.96 2.55 1.45 3.82l.03.12c.22 1.35.45 2.7.69 4.05l-1.08.28z"
        fill="url(#h)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M871.61 811.62l-2.15-1.42c-3.02-2.9-5.95-5.74-8.88-8.58-4.45-4.31-8.9-8.62-13.36-12.9l.71-.9 7.35 5.91c4.81 3.87 9.62 7.73 14.44 11.58l.2.22 1.29 1.52v.2c.07 1.06.16 2.11.28 3.16l.13 1.21zm-14.46-14.91c1.39 1.35 2.79 2.7 4.18 4.05 2.93 2.84 5.86 5.68 8.8 8.51l.13.08c-.06-.61-.1-1.22-.14-1.82l-1.16-1.37c-3.9-3.1-7.85-6.27-11.81-9.46zM600.28 550.18c-.43-.86-.86-1.72-1.28-2.59-3.42-6.99-6.63-14.25-9.53-21.59-.9-4.58-1.66-9.17-2.3-13.73l-.52-3.79 1.57 3.45c.66 1.46 1.34 2.91 2.02 4.36 2.99 11.51 6.69 22.7 11.04 33.39l-1 .5zm-11.46-34.28c.5 3.28 1.07 6.55 1.7 9.77 1.54 3.89 3.19 7.79 4.91 11.65a266.22 266.22 0 01-6.22-20.61l-.39-.81zm-6.76-10.57l-1.57-5.27c-.39-1.29-.76-2.58-1.13-3.88-.25-1.42-.48-2.77-.71-4.13l-.86-5.29 1.92 4.97c.49 1.26.98 2.51 1.48 3.77l.04.18c.1 1.38.21 2.77.34 4.15l.49 5.5z"
        fill="url(#i)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M871.69 812.36l-2.31-2.23.67-.93 1.4.93.24 2.23zM589.47 526.01c-2.18-5.51-4.24-11.19-6.12-16.86-.98-2.97-1.94-6.02-2.86-9.08l-.02-.12c-.12-1.39-.23-2.78-.34-4.17l-.26-3.6 1.33 3.33c1.13 2.83 2.3 5.67 3.49 8.44 1.14 2.68 2.33 5.37 3.53 8l.05.17c.63 4.54 1.39 9.1 2.25 13.56l-1.06.34zm-7.89-26.24c.9 3.03 1.86 6.06 2.83 8.99 1.25 3.77 2.58 7.55 3.97 11.27a249.1 249.1 0 01-1.18-7.67c-1.19-2.61-2.37-5.29-3.51-7.94-.72-1.69-1.44-3.4-2.14-5.12.01.16.03.31.04.47z"
        fill="url(#j)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M601.33 540.11c-4.27-7.53-8.33-15.36-12.08-23.3-.42-1.57-.78-3.04-1.14-4.51-.7-2.89-1.36-5.83-1.96-8.74l-.77-3.7 1.79 3.28c.77 1.41 1.55 2.81 2.33 4.21 3.7 11.1 7.99 21.89 12.8 32.2l-.97.56zm-13.3-33.1a311.182 311.182 0 002.25 9.38c1.78 3.76 3.65 7.53 5.58 11.26-2.67-6.49-5.13-13.11-7.36-19.81-.16-.27-.31-.55-.47-.83zm-7.42-9.88l-1.92-4.96c-.49-1.27-.98-2.55-1.46-3.83-.37-1.41-.71-2.76-1.04-4.11l-1.27-5.15 2.3 4.74c.6 1.25 1.22 2.49 1.83 3.73l.06.18c.2 1.38.42 2.75.64 4.13l.86 5.28z"
        fill="url(#k)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M589.25 516.81c-.69-1.45-1.36-2.91-2.03-4.37l-.05-.17c-.4-2.91-.76-5.88-1.07-8.85l-.28-2.7 1.41 2.59a280.764 280.764 0 003.04 13.08l-1.03.42zm-7.74-17.53l-1.33-3.33c-.5-1.26-1-2.52-1.48-3.78l-.03-.12c-.22-1.38-.44-2.76-.64-4.14l-.52-3.51 1.56 3.15c.61 1.23 1.22 2.46 1.85 3.68l.07.24c.08 1.41.17 2.81.28 4.21l.26 3.6zm-1.76-7.49l.15.39-.03-.52c-.07-.14-.14-.27-.21-.41.03.18.06.36.09.53z"
        fill="url(#l)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M588.8 515.89l-1.57-3.45a360.87 360.87 0 01-7.05-16.49l-.04-.18c-.1-1.41-.2-2.82-.28-4.23l-.15-2.67 1.2 2.36c1.31 2.59 2.66 5.19 4.01 7.72.73 1.38 1.48 2.76 2.22 4.13l.07.23c.31 2.95.66 5.92 1.06 8.81l.52 3.79zm-7.56-20.31c1.12 2.8 2.28 5.61 3.45 8.35.65 1.52 1.32 3.05 1.99 4.57-.2-1.65-.39-3.31-.56-4.96a446.779 446.779 0 01-4.98-9.4c.03.48.07.96.1 1.44z"
        fill="url(#m)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M871.84 801.21l-3.46-4.09c-5.23-6.18-10.82-12.75-16.55-19.28-2.54-3.49-4.89-6.65-7.22-9.7-11.78-15.44-23.4-28.54-35.53-40.04-21.6-20.33-44.35-38.87-65.71-55.88-4.67-3.73-9.35-7.45-14.04-11.17-17.6-13.96-35.79-28.4-53.01-43.66l-5.3-4.75-8.92-8.43-6.52-6.49-6.95-7.35c-1.51-1.63-2.99-3.28-4.48-4.93-.77-.85-1.53-1.71-2.3-2.55-4.84-5.49-9.12-10.55-13.08-15.46a425.27 425.27 0 01-23.98-32.81c-.84-1.26-1.66-2.53-2.48-3.81-4.99-9.27-9.64-18.9-13.82-28.69-.4-.95-.81-1.89-1.2-2.84l.96-.57c5.04 7.63 10.28 15.17 15.59 22.41 2.02 3.26 4.1 6.5 6.19 9.66a419.03 419.03 0 0023.6 32.29c3.86 4.8 8.07 9.78 12.87 15.23.8.89 1.61 1.78 2.42 2.68 1.42 1.57 2.83 3.15 4.27 4.7l6.84 7.23 7.48 7.45 7.69 7.21 5.24 4.69c17.04 15.11 35.21 29.52 52.78 43.46 4.67 3.71 9.34 7.41 14 11.14 21.47 17.1 44.34 35.74 66.11 56.22 12.41 11.76 24.26 25.11 36.25 40.84 1.76 2.3 3.59 4.74 5.43 7.24 4.35 7.24 8.88 15.25 14.27 25.27l2.56 4.77z"
        fill="url(#n)"
      />
      <Path
        d="M872.12 801.63c-3.34-2.85-7.77-8.29-10.79-11.66-.02-.02-10.12-11.57-10.14-11.59.02 0-6.68-8.8-6.68-8.81-15.53-20.46-33.53-38.87-53.05-55.53-41.36-36.43-87.17-67.75-127.45-105.48-13.47-12.63-25.53-26.67-37.16-40.98-9.13-11.63-17.69-23.7-25.53-36.22-2.69-5.19-5.24-10.44-7.66-15.75-2.44-5.31-4.7-10.69-6.83-16.13l-.16-.41.37-.22.96-.57.41-.24.26.4c5.01 7.59 10.2 15.06 15.58 22.39 7.84 12.6 16.33 24.8 25.46 36.5 10.27 12.89 21.39 25.9 33.02 37.57 41.05 40.38 89.17 72.6 132.16 110.8 22.62 19.29 43.17 41.02 60.53 65.19 2.98 4.93 5.84 9.93 8.64 14.97l4.15 7.55 1.02 1.89.51.95c.92 1.65 1.75 3.79 2.39 5.39zm-.56-.83c-1.01-1.51-1.97-2.62-2.71-4.09-.27-.51-1.24-2.28-1.53-2.84-4.03-7.42-8.42-15.27-12.74-22.44-8.65-11.74-18.09-23.55-28.13-34.36-41.14-42.91-90.52-76.72-135.66-115.17-11.3-9.6-22.42-19.57-32.68-30.29-20.44-21.4-39.19-45.14-54.67-70.2a557.588 557.588 0 01-15.61-22.43l.67.15-.96.57s.2-.67.21-.61c4.74 10.62 9.86 21.06 15.54 31.18 17.74 26.74 39.76 53.25 63.23 75.62 45.68 42.64 98.03 77.55 143.12 120.91 16.06 15.25 30.05 32.55 42.86 50.54-.18-.24 9.88 11.73 9.87 11.71 2.11 2.57 7.47 8.57 9.19 11.73z"
        fill="#40a840"
      />
      <Path
        d="M574.42 480.56c-1.2-2.52-2.37-5.04-3.52-7.58l.97-.56 2.16 3.66.05.11c.44 1.3.89 2.61 1.35 3.91l-1.02.47z"
        fill="url(#o)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M871.1 804.25l-2.55-2.48c-5.27-7.73-10.95-15.98-16.75-23.96l.85-.75c5.73 6.53 11.32 13.11 16.56 19.29l.07.1c.65 1.2 1.29 2.41 1.94 3.62l.08.16-.18 2.72-.02 1.31zm-1.68-3.22l.65.63.09-1.19c-.61-1.13-1.21-2.27-1.82-3.4-2.81-3.32-5.73-6.76-8.72-10.24 3.37 4.81 6.65 9.59 9.79 14.19zM602.31 530.82c-4.77-7.41-9.4-15.1-13.75-22.87l-.22-.64c-.91-2.75-1.8-5.56-2.63-8.35l-.02-.12c-.07-.8-.13-1.61-.2-2.42l-.17-2.19 1.18 1.81c.58.9 1.17 1.79 1.76 2.68.45 1.05.85 1.99 1.25 2.94 4.17 9.75 8.79 19.36 13.75 28.55l-.94.62zm-15.53-32.16c.83 2.76 1.71 5.54 2.61 8.26l.18.54c2.08 3.7 4.23 7.41 6.44 11.09-2.64-5.39-5.15-10.88-7.52-16.42-.4-.95-.81-1.89-1.2-2.84-.17-.25-.34-.51-.52-.78v.15zm-8.21-9.56l-2.31-4.75c-.61-1.26-1.22-2.52-1.82-3.79-.48-1.36-.93-2.67-1.38-3.98l-1.72-5.05 2.71 4.54c.73 1.22 1.46 2.44 2.2 3.66l.07.18c.32 1.35.64 2.7.97 4.04l1.27 5.16z"
        fill="url(#p)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M587.24 504.12l-1.55-5.17c-.39-1.28-.76-2.57-1.13-3.85l-1.05-3.65 3.05 4.71v.16l.21 2.41.47 5.39z"
        fill="url(#q)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M588.55 507.95c-.79-1.4-1.56-2.81-2.34-4.22l-.13-.49c-.16-1.51-.29-2.96-.42-4.41l-.46-5.38 1.55 5.15c.83 2.78 1.72 5.58 2.62 8.32l.18.54-1 .49zm-8.91-16.71l-1.57-3.15c-.62-1.24-1.23-2.49-1.84-3.74l-.04-.12c-.33-1.35-.66-2.7-.97-4.05l-.81-3.45 1.81 2.99c.73 1.21 1.47 2.42 2.21 3.62l.08.24c.19 1.38.38 2.77.59 4.15l.52 3.51zm-2.38-7.36c.09.18.17.36.26.54-.02-.18-.05-.36-.07-.54-.1-.17-.21-.34-.31-.51l.12.51z"
        fill="url(#r)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M586.09 503.24c-.56-2.74-1.09-5.51-1.58-8.26l-.48-2.71 1.59 2.49c.37 1.28.74 2.56 1.13 3.84l.02.12c.12 1.44.26 2.89.41 4.33l-1.09.19z"
        fill="url(#s)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M588.05 507.27l-1.96-3.97v-.05l1.08-.25.87 4.27zm-8.12-15.49c-.62-1.23-1.24-2.46-1.85-3.69l-.06-.18c-.21-1.39-.4-2.77-.59-4.16l-.36-2.63 1.37 2.22c.74 1.2 1.48 2.39 2.22 3.58l.08.14v.16c.07 1.42.14 2.83.22 4.24m-1.87-3.83c.21.41.41.83.62 1.24-.02-.48-.04-.96-.07-1.44-.25-.41-.51-.81-.76-1.22l.21 1.41z"
        fill="url(#t)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M587.51 506.1l-1.34-2.45c-.75-1.37-1.49-2.75-2.23-4.14-1.35-2.54-2.7-5.14-4.02-7.74l-.07-.24c-.08-1.42-.15-2.84-.21-4.26l-.09-2.12 1.11 1.77c1.44 2.3 2.89 4.59 4.36 6.86l.58.98c.48 2.73 1.01 5.5 1.57 8.22l.03.3.3 2.81zm-6.55-14.77c1.3 2.55 2.63 5.11 3.95 7.6.17.31.33.62.5.94-.31-1.6-.6-3.19-.88-4.77l-.42-.66c-1.09-1.69-2.18-3.39-3.25-5.1.03.66.07 1.33.11 1.99z"
        fill="url(#u)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M871.11 805.53L865.38 797.13 871.12 802.68 871.11 805.53z"
        fill="url(#v)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M602.96 521.84a550.979 550.979 0 01-15.62-22.45c-.7-1.65-1.34-3.2-1.96-4.76l-.04-.19c-.1-1.4-.18-2.79-.26-4.19l-.1-1.81 1.45 1.88c1.06 2.04 2.07 3.98 3.1 5.9a434.39 434.39 0 0014.35 24.94l-.9.68zm-16.53-27.58c.61 1.52 1.23 3.04 1.87 4.56 2.43 3.67 4.92 7.35 7.45 10.99-2.47-4.29-4.88-8.63-7.21-13-.75-1.41-1.49-2.82-2.23-4.24.04.57.07 1.14.11 1.71zm-10.64-13.03l-2.7-4.54c-.73-1.22-1.45-2.44-2.17-3.66-.62-1.35-1.2-2.65-1.78-3.95l-2.2-4.95 3.14 4.35c.86 1.18 1.71 2.36 2.57 3.54l.09.17c.44 1.33.88 2.66 1.33 3.99l1.71 5.05z"
        fill="url(#w)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M586.68 497.9l-1.31-3.27c-.53-1.33-1.06-2.66-1.58-3.99l-.03-.12c-.13-.8-.25-1.6-.37-2.39l-.33-2.18 3.11 4.06v.19c.08 1.39.17 2.78.27 4.17l.25 3.54zm-1.84-7.64c.09.22.17.45.26.67 0-.16-.02-.32-.03-.48l-.26-.34.02.15z"
        fill="url(#x)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M585.68 495.5l-1.89-4.86c-.49-1.27-.98-2.53-1.45-3.81l-1.35-3.6 3.47 4.54.02.15c.12.8.25 1.59.37 2.38l.83 5.18z"
        fill="url(#y)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M577.11 483.35l-1.82-2.99c-.74-1.22-1.47-2.44-2.2-3.66l-.05-.12c-.45-1.33-.9-2.67-1.34-4l-1.12-3.4 2.08 2.85c.86 1.18 1.73 2.36 2.6 3.54l.1.23c.3 1.37.62 2.74.94 4.11l.81 3.45zm-3.05-7.22c.12.21.25.42.38.63-.04-.19-.08-.38-.13-.57l-.42-.57c.06.17.12.34.17.52z"
        fill="url(#z)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M586.75 498.5l-2.26-3.63c-.27-1.49-.51-2.93-.74-4.36l-.84-5.21 1.9 4.89c.52 1.33 1.04 2.66 1.57 3.98l.04.19c.05.65.09 1.31.14 1.96l.17 2.18z"
        fill="url(#A)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M584.49 494.86c-.76-2.67-1.51-5.41-2.22-8.15l-.68-2.64 1.78 2.32c.48 1.27.96 2.53 1.45 3.79l.03.12c.23 1.43.47 2.85.72 4.27l-1.08.28z"
        fill="url(#B)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M578.88 486.21l-1.37-2.22-2.22-3.63-.07-.18c-.32-1.37-.63-2.75-.94-4.13l-.57-2.6 1.55 2.1c.87 1.17 1.73 2.34 2.61 3.51l.1.13.02.16c.17 1.41.35 2.81.54 4.22l.35 2.63zm-2.6-6.4c.27.44.54.88.8 1.32l-.18-1.46c-.32-.42-.63-.85-.95-1.27l.33 1.41z"
        fill="url(#C)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M586.7 498.43L584.51 494.99 584.48 494.8 585.56 494.52 586.7 498.43z"
        fill="url(#D)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M580.85 489.34l-1.11-1.77c-.75-1.19-1.49-2.39-2.23-3.59l-.08-.24c-.19-1.41-.37-2.82-.54-4.24l-.25-2.1 1.24 1.66c.87 1.16 1.74 2.33 2.62 3.48l.12.15v.19c.04 1.44.1 2.88.16 4.32l.09 2.12zm-2.34-5.89c.35.57.7 1.14 1.06 1.71-.02-.67-.05-1.35-.06-2.02-.42-.55-.84-1.11-1.25-1.66.08.66.17 1.32.26 1.98z"
        fill="url(#E)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M586.1 497.52l-1.99-3.07c-1.47-2.28-2.93-4.58-4.37-6.88l-.08-.14v-.16c-.07-1.45-.12-2.89-.16-4.33l-.05-1.76 1.04 1.37c.92 1.21 1.83 2.42 2.76 3.63l.1.21c.71 2.73 1.45 5.46 2.21 8.12l.54 2.99zm-5.35-10.46c.93 1.48 1.86 2.95 2.8 4.43-.42-1.54-.84-3.1-1.24-4.66l-1.65-2.16.09 2.39z"
        fill="url(#F)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M871.27 800.55l-2.96-3.52c-5.38-10-9.9-18-14.21-25.18l.91-.67c4.29 5.83 8.71 12.08 14.34 20.27l.06.11c.72 1.76 1.44 3.53 2.15 5.3l.07.16-.13.71-.22 2.82zm-2.03-4.15l1.13 1.34.09-.59c-.68-1.69-1.36-3.38-2.05-5.07-2.72-3.95-5.15-7.45-7.43-10.67 2.56 4.51 5.28 9.44 8.26 14.98z"
        fill="url(#G)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M871.13 802.29l-.88-1.66c-.64-1.2-1.29-2.41-1.94-3.61l-2.57-4.76 5.66 6.68-.27 3.36z"
        fill="url(#H)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M893.77 832.55l-1.71-1.15-2.38-3.65 2.67 2.08-.33.47.36-.45c.72.62 1.38 1.18 2.03 1.75l-.64.96z"
        fill="url(#I)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M891.76 830.82l-.22-.22-2.05-3.24 2.86 2.46-.07.13.1-.11-.19.3.27-.19-.27.19.27-.19-.29.22-.42.65zm.54-.93l-.3.39.3-.39z"
        fill="url(#J)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M871.43 791.53l-2.49-4.52c-4.4-7.99-8.41-14.94-12.27-21.23-1.56-3.16-3.11-6.19-4.65-9.06-8.93-16.75-19.24-31.71-30.66-44.46-9.51-10.54-20.06-21.08-32.27-32.23-1-.89-2-1.8-2.99-2.71-1.78-1.62-3.63-3.3-5.49-4.89l-9.34-8.07c-5.49-4.6-11.16-9.35-16.83-13.9-11.65-9.42-23.6-18.71-35.83-28.19l-1.94-1.5c-11.2-8.68-22.79-17.66-33.95-26.91l-8.19-6.95-8.04-7.2-7.42-6.99a507.69 507.69 0 01-4.72-4.56c-.86-.84-1.72-1.68-2.59-2.52-5.58-5.49-10.13-10.09-14.33-14.47a727.883 727.883 0 01-34.27-38.2c-5.03-7.04-9.97-14.32-14.71-21.66-1.18-1.84-2.36-3.68-3.52-5.53l-.09-.14-.09-2.64 1.01 1.08c5.96 6.56 12.01 13.07 17.97 19.34 3.63 4.43 7.31 8.81 10.96 13.05 8.74 10.17 17.9 20.23 27.22 29.91 4.2 4.38 8.71 8.93 14.2 14.33.87.84 1.73 1.68 2.6 2.53 1.54 1.5 3.08 3 4.64 4.48l7.33 6.91 9.22 8.19 6.77 5.74c11.09 9.19 22.69 18.18 33.91 26.88l1.8 1.39c12.27 9.5 24.25 18.82 35.94 28.27 5.84 4.69 11.69 9.59 17.35 14.33l.33.27 8.69 7.52c1.89 1.63 3.76 3.33 5.58 4.98.99.9 1.99 1.81 2.99 2.7 12.38 11.31 23.09 22 32.73 32.69 11.79 13.17 22.41 28.57 31.59 45.8 1.02 1.91 2.02 3.82 3 5.75 3.36 8.44 6.42 17.38 9.38 27.38l1.48 4.99z"
        fill="url(#K)"
      />
      <Path
        d="M871.62 791.99c-.67-1-1.57-2.04-2.36-3.27l-2.02-3.35c-2.32-3.75-9.08-15.09-11.49-19.08-6.82-13.35-14.62-26.17-23.65-38.05-8.95-11.96-19.47-22.6-30.15-33.01-40.2-39.12-87.94-70.65-130.39-107.16-25.23-22.64-48.58-47.66-69.66-74.18-4.89-7.87-13.17-20.1-17.54-28.22l-.09-2.64-.05-1.34.91.98 19 20.44 7.32 8.72c12.07 14.42 25.17 28.65 38.5 41.95 53.06 54.54 120.77 92.62 172.25 148.97 15.73 16.6 28.55 35.84 38.84 56.23 3.16 7.95 5.94 16.05 8.43 24.23.87 2.7 1.79 6.05 2.15 8.79zm-.39-.92c-.53-1.35-1.16-2.43-1.52-3.59l-1.2-3.98c-2.44-8.07-5.34-16.43-8.38-24.11-6.86-13.53-14.76-26.55-23.95-38.62-9.18-12.09-19.82-22.99-30.65-33.6-43.37-42.77-95.35-75.4-140.01-116.71-19.21-18.27-37.81-37.65-54.84-57.98l-7.33-8.74c.09.1-18.96-20.39-18.96-20.39l.86-.36.09 2.64-.08-.25c5.16 7.51 13.77 19.11 19.16 26.67 19.35 22.04 40.74 43.99 62.55 64.24 50.12 44.81 108.67 81.51 153.64 132.19 15.27 16.8 27.35 36.38 36.99 56.82-.14-.32 7.16 12.93 7.18 12.91l3.58 6.51.9 1.63c.96 1.62 1.16 2.88 1.96 4.71z"
        fill="#40a840"
      />
      <Path
        d="M566.63 465.6c-1.73-2.41-3.44-4.84-5.15-7.27l.86-.74c.99 1.15 1.99 2.31 2.99 3.46l.07.1c.71 1.27 1.43 2.54 2.15 3.8l-.92.65z"
        fill="url(#L)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M586.04 487.54l-1.09-1.74c-.63-1-1.26-2.01-1.88-3.02l.87-.72 2 2.2.12 3.28z"
        fill="url(#M)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M603.17 512.98a756.093 756.093 0 01-17.62-21.92l-.5-1.08c-.08-1.5-.15-2.99-.2-4.49l-.08-2.09 1.1 1.74a574.397 574.397 0 0018.17 27.1l-.86.74zm-17.02-23.19l.32.62c2.79 3.59 5.62 7.19 8.49 10.75-2.2-3.25-4.37-6.54-6.5-9.84-.81-1.26-1.62-2.52-2.42-3.78.03.75.07 1.5.11 2.25zm-13.8-16.23l-3.15-4.36c-.86-1.19-1.72-2.39-2.58-3.59l-2.19-3.86-2.73-4.86 3.61 4.17c.99 1.15 1.99 2.29 2.99 3.44l.1.15c.57 1.32 1.15 2.63 1.73 3.94l2.21 4.97z"
        fill="url(#N)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M584.69 489.42l-1.54-3.09c-.66-1.32-1.31-2.64-1.95-3.96l-.04-.12c-.19-.76-.37-1.52-.55-2.29l-.51-2.17 3.51 3.9.02.19c.18 1.37.37 2.73.57 4.09l.5 3.45zm-2.48-7.53l.4.81-.06-.48-.35-.38s0 .03.01.04z"
        fill="url(#O)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M580.52 481.36L577.84 474.78 580.52 478.26 580.52 481.36z"
        fill="url(#P)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M583.48 487.04l-2.28-4.68c-.58-1.19-1.16-2.38-1.73-3.58l-.06-.12v-1.61l2.23 2.48.04.15c.18.76.36 1.52.55 2.28l1.25 5.1z"
        fill="url(#Q)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M871.66 796.82l-.76-1.11c-.82-1.19-1.63-2.38-2.45-3.58l-.06-.11c-4.06-9.89-7.9-18.49-11.74-26.29l.96-.59c3.87 6.31 7.89 13.27 12.29 21.28l.05.12c.74 2.49 1.45 4.99 2.14 7.5l.04.14-.48 2.63zm-2.27-5.32c.48.69.95 1.38 1.42 2.07-.62-2.21-1.25-4.41-1.9-6.61-2.17-3.94-4.25-7.63-6.26-11.11 2.2 4.87 4.43 10.06 6.73 15.66z"
        fill="url(#R)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M585.56 491.06l-.48-.62-.19-3.12 1.58 3.09-.92.65zm-11.69-15.48l-2.08-2.84c-.86-1.18-1.72-2.36-2.58-3.55l-.06-.11c-.58-1.31-1.16-2.63-1.74-3.95l-1.45-3.35 2.37 2.71c1 1.14 1.99 2.28 2.99 3.42l.12.21c.43 1.36.87 2.72 1.31 4.07l1.11 3.39zm-3.74-7.05l.48.66-.18-.58c-.17-.2-.35-.4-.52-.6.07.17.15.34.23.51z"
        fill="url(#S)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M584.81 490.1l-2.47-3.27-.09-.24c-.39-1.49-.75-2.91-1.1-4.35l-1.24-5.09 2.27 4.67c.64 1.32 1.29 2.64 1.95 3.95l.06.19c.1.66.19 1.31.29 1.97l.33 2.17z"
        fill="url(#T)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M580.52 482.02L578.44 475.99 580.5 478.35 580.52 478.68 580.52 482.02z"
        fill="url(#U)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M582.25 486.59a359.8 359.8 0 01-2.8-7.71l-.04-.35-.05-2.59 1.1 2.3c.57 1.19 1.14 2.38 1.72 3.57l.04.12c.35 1.43.71 2.85 1.07 4.27l-1.05.37z"
        fill="url(#V)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M575.94 478.39l-1.56-2.11c-.87-1.18-1.74-2.36-2.6-3.54l-.08-.17-1.32-4.08-.82-2.58 1.75 1.99c1 1.14 2 2.28 3.01 3.41l.1.12.03.16c.29 1.4.59 2.8.9 4.19l.58 2.6zm-3.22-6.29l1 1.36c-.1-.49-.21-.98-.31-1.46l-1.14-1.29c.15.46.3.93.45 1.39z"
        fill="url(#W)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M584.73 489.97L582.27 486.71 582.23 486.53 583.28 486.16 584.73 489.97z"
        fill="url(#X)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M578.24 481.46l-1.24-1.67c-.87-1.17-1.74-2.34-2.61-3.52l-.1-.23c-.31-1.4-.61-2.8-.9-4.21l-.44-2.09 1.39 1.57c1 1.13 2.01 2.27 3.02 3.4l.13.14.02.19c.16 1.44.32 2.87.49 4.31l.25 2.1zm-2.9-5.8c.43.58.86 1.17 1.3 1.75-.08-.68-.15-1.36-.23-2.03-.5-.56-1-1.12-1.5-1.69.14.66.28 1.31.43 1.97z"
        fill="url(#Y)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M580.65 484.66l-1.04-1.38c-.87-1.16-1.75-2.32-2.62-3.49l-.1-.13-.02-.16c-.17-1.44-.34-2.88-.5-4.32l-.19-1.76 1.15 1.29c.97 1.09 1.95 2.19 2.93 3.28l.16.32.09.36c.02 1.41.05 2.82.09 4.23l.05 1.76zm-2.69-5.46c.49.66.99 1.32 1.49 1.99-.02-.8-.03-1.6-.04-2.4l-.03-.08c-.57-.63-1.13-1.27-1.7-1.9.09.8.18 1.59.28 2.39z"
        fill="url(#Z)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M584.01 489l-1.63-2.07c-.92-1.21-1.84-2.42-2.76-3.64l-.12-.15v-.19c-.04-1.42-.07-2.83-.09-4.25l-.04-3.39 1.12 3.18c.91 2.6 1.85 5.18 2.79 7.68l.04.16.68 2.68zm-3.41-6.29c.14.18.27.36.41.54-.14-.39-.29-.78-.43-1.18l.02.63z"
        fill="url(#aa)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M871.24 799.09l-.71-1.78c-.71-1.77-1.42-3.53-2.14-5.29l-2.01-4.89 2.97 4.31c.82 1.19 1.64 2.39 2.46 3.58l.14.2-.7 3.86z"
        fill="url(#ab)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M585.87 482.63l-1.03-1.35c-.94-1.23-1.87-2.47-2.8-3.71l-.1-.13-.3-2.63 4.15 3.91v.26c.01.64.02 1.28.04 1.92l.04 1.73z"
        fill="url(#ac)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M583.27 479.21l-1.23-1.64c-.69-.93-1.39-1.86-2.08-2.78l.81-.8 2.12 2.01.38 3.21z"
        fill="url(#ad)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M584.97 484.9l-.15-.16v-.22c-.05-1.2-.08-2.39-.11-3.59l-.04-1.73 1.03 1.35c1.13 1.49 2.26 2.97 3.4 4.45 4.8 6.24 9.73 12.45 14.66 18.46l-.81.8m-17.04-20.01c2.56 2.82 5.13 5.62 7.71 8.4-1.81-2.29-3.6-4.6-5.38-6.91l-2.38-3.1c.02.54.03 1.08.05 1.62zm-17.78-18.24l-3.62-4.17c-1-1.15-2-2.3-2.99-3.46l-1.57-2.25c-.36-.51-.7-1.01-1.05-1.5l.82-.78 3.5 3.4.84 1.48c.46.82.9 1.62 1.35 2.42l2.74 4.87z"
        fill="url(#ae)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M585.98 486.01l-2.86-3.15-.64-1.11c-.2-1.49-.38-2.98-.55-4.47l-.24-2.08 1.23 1.64c.93 1.24 1.86 2.47 2.79 3.7l.12.16v.2c.03 1.19.06 2.38.1 3.57l.05 1.54zm-2.41-4.56l.42.68.78.85c-.02-.62-.03-1.24-.05-1.86-.48-.64-.96-1.27-1.44-1.91.09.75.19 1.49.28 2.24z"
        fill="url(#af)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M580.52 479.78L578.83 472.12 580.48 473.71 580.52 479.78z"
        fill="url(#ag)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M583.92 484.17l-1.35-2.19c-.79-1.28-1.58-2.56-2.36-3.85l-.07-.18c-.25-1.08-.49-2.17-.74-3.25v-.13l-.03-1.92 1.41 1.34 2.14 2.85.1.13.02.16c.17 1.49.36 2.97.55 4.45l.34 2.59zm-2.73-6.59c.32.53.64 1.05.97 1.58l-.21-1.72c-.38-.51-.76-1.02-1.14-1.52.13.56.25 1.11.38 1.67z"
        fill="url(#ah)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M580.52 478.65l-1.04-1.71c-.54-.89-1.08-1.79-1.62-2.69l-.05-.12c-.25-.72-.49-1.44-.73-2.17l-.72-2.16 3.91 3.72.22 1.05.02 4.08zm-1.62-4.87c.16.26.31.53.47.79l-.09-.43-.38-.36z"
        fill="url(#ai)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M582 481.09l-2.61-4.29-.07-7.58 1.16 5.22c.24 1.08.48 2.16.73 3.24l.79 3.41z"
        fill="url(#aj)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M577.33 473.33L573.79 467.35 576.69 470.11 576.32 470.55 576.77 470.19 576.93 470.33 577.05 470.78 577.33 473.33z"
        fill="url(#ak)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M580.54 478.71l-2.68-4.47c-.62-1.03-1.23-2.06-1.84-3.09l-.08-.24-.17-1.54 1.08.89 1.23 1.17.05.14.72 2.16 1.69 4.98z"
        fill="url(#al)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M569.88 468l-2.37-2.71c-1-1.15-2-2.29-2.99-3.44l-.07-.1c-.45-.8-.9-1.6-1.34-2.4l-2.8-4.93 6.37 6.18.62 1.43c.38.89.75 1.75 1.13 2.61l1.45 3.35zm-4.5-6.9l.59.68-.25-.57-.6-.58c.09.16.18.32.27.47zm-13.07-23.24l-4.08-2.49-.72-1.02.84-.76 3.96 4.27z"
        fill="url(#am)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M583.12 482.86L582.54 482.22 582.14 479.17 583.99 482.13 583.12 482.86z"
        fill="url(#an)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M583.84 483.65l-3.2-3.55-1.29-5.55 1.79 2.95c.78 1.28 1.57 2.57 2.36 3.84l.08.24.26 2.07z"
        fill="url(#ao)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M580.54 479.94l-1.15-1.32-.13-.28c-.51-1.44-.98-2.82-1.45-4.21l-1.68-4.99 2.68 4.48c.54.9 1.08 1.79 1.62 2.69l.09.14v.17c0 .63 0 1.25.02 1.88l.02 1.44z"
        fill="url(#ap)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M582.19 481.83l-2.78-3.1v-.23c-.01-.63-.02-1.26-.02-1.89v-2.03l1.82 3.09.98 4.16z"
        fill="url(#aq)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M577.44 474.49L574.5 468.05 576.79 470.24 577.03 470.65 577.44 474.49z"
        fill="url(#ar)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M579.26 478.34c-1.09-2.3-2.17-4.61-3.23-6.94l-.08-.5-.27-2.57 1.3 2.2c.61 1.03 1.22 2.06 1.83 3.08l.05.12c.47 1.38.94 2.76 1.42 4.14l-1.02.47z"
        fill="url(#as)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M572.25 470.7l-1.75-1.99-3-3.42-.1-.15c-.37-.86-.75-1.73-1.12-2.59l-1.78-4.07 5.57 5.34.48 1.51c.29.95.58 1.88.88 2.81l.82 2.58zm-3.87-6.14c.4.46.8.91 1.19 1.37-.02-.07-.05-.15-.07-.22l-.39-1.23-1.32-1.26c.2.45.39.91.59 1.35z"
        fill="url(#at)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M582.1 481.69L579.35 478.6 579.23 478.28 580.25 477.82 582.1 481.69z"
        fill="url(#au)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M574.9 473.69l-1.39-1.57c-1.01-1.14-2.01-2.27-3.01-3.41l-.12-.21-.87-2.79-1.12-3.52 5.15 4.93.31 1.48c.21 1.02.41 2.01.62 3l.44 2.1zm-3.5-5.69l1.55 1.76-.18-.9-.24-1.13-1.74-1.66c.2.65.4 1.29.61 1.93z"
        fill="url(#av)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M577.68 476.81l-1.15-1.29c-1.01-1.13-2.01-2.27-3.02-3.4l-.1-.12-.03-.16c-.21-1-.41-1.99-.61-2.99l-.65-3.11 4.58 4.43.38.91.08.78c.11 1.08.22 2.14.33 3.19l.19 1.75zm-3.25-5.37c.59.67 1.18 1.33 1.77 2-.05-.48-.1-.95-.14-1.43l-.07-.69-.24-.53-1.8-1.72c.16.8.32 1.58.49 2.36z"
        fill="url(#aw)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M581.33 480.88l-1.86-2.08c-.98-1.09-1.96-2.18-2.93-3.28l-.13-.14-.02-.19-.33-3.18-.44-4.2 1.41 3.1c1.06 2.32 2.13 4.62 3.22 6.92l1.08 3.06zm-3.86-6.02c.11.12.21.24.32.35-.12-.26-.24-.51-.36-.77l.05.42z"
        fill="url(#ax)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M892.16 831.53L888.53 829.19 888.23 828.65 889.13 827.97 892.16 831.53z"
        fill="url(#ay)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M889.57 829.18l-1.84-1.46c-.17-.31-.33-.62-.49-.92l-1.44-2.76 2.57 2.27c.66.68 1.29 1.33 1.92 1.97l-.71.9z"
        fill="url(#az)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M887.64 827.21L887.23 826.8 885.38 823.27 888.39 826.34 887.64 827.21z"
        fill="url(#aA)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M894.45 832.98l-3.1-1.99c-.62-.62-1.23-1.24-1.85-1.87l.71-.9 2.26 1.74 1.98 3.02z"
        fill="url(#aB)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M891.7 830.77l-2.13-1.6c-.7-.7-1.33-1.35-1.96-2l.75-.87c1.33 1.18 2.66 2.35 4 3.51l.11.13-.77.82z"
        fill="url(#aC)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M886.75 820.18l-1.9-1.47c-.69-.53-1.37-1.06-2.05-1.59l-.12-.1-.06-.15c-.35-.87-.68-1.75-1-2.63l-.82-2.25 1.7 1.6 1.9 1.78.13.19c.37.81.75 1.61 1.14 2.41l1.08 2.21zm-3.17-3.91l.07.05s-.05-.1-.07-.15l-.06-.06.06.15z"
        fill="url(#aD)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M887.85 822.23l-4.09-2.66-.39-.91c-.25-.6-.5-1.19-.74-1.79l-.79-1.97 1.63 1.27c.68.53 1.37 1.06 2.05 1.59l.11.08.06.12c.26.53.52 1.06.79 1.59.13.24.26.49.39.74l.99 1.92zm-3.22-3.47l.28.18c-.05-.1-.1-.2-.15-.31-.09-.07-.18-.14-.28-.21l.15.34z"
        fill="url(#aE)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M894.71 833.38l-3.06-2.65c-1.34-1.16-2.68-2.34-4.01-3.52l-.46-.5a111.15 111.15 0 01-3.5-7.29l-.77-1.77 3.88 2.52.45.88c.44.87.89 1.76 1.4 2.59l2.37 4.04c.47.75.96 1.51 1.46 2.27l2.25 3.44zm-6.59-7.32l.27.28c.36.32.73.65 1.1.97l-1.78-3.05c-.53-.86-1-1.78-1.44-2.67l-.3-.6-.46-.3c.84 1.82 1.72 3.62 2.63 5.36z"
        fill="url(#aF)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M889.27 829.67l-4.13-2.66-.07-.15c-.28-.6-.56-1.21-.83-1.81l-.93-2.06 2.42 1.88.36.51c.41.58.84 1.16 1.27 1.74l1.91 2.56z"
        fill="url(#aG)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M887.87 827.92l-3.57-2.75-.51-1.16.95-.59c.33.48.66.95.99 1.43l2.14 3.07z"
        fill="url(#aH)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M892 834.97l-2.54-3.16-1.43-1.92c-.33-.45-.67-.9-1-1.34l-2.45-3.28 4.78 3.07.07.13c1.1 1.99 2.27 3.94 3.46 5.8l-.88.71zm-10.14-23.2l-3.52-5.26c-.16-.98-.3-1.95-.41-2.88l-.33-2.95 2.66 5.07c.21.92.44 1.83.69 2.74l.91 3.28z"
        fill="url(#aI)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M890.53 830.47l-4.05-2.65c-.43-.58-.86-1.17-1.28-1.76l-2.5-3.57 5.18 3.97c.42.5.83 1 1.25 1.5l1.4 2.5z"
        fill="url(#aJ)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M891.09 830.34l-6.25-4.79c-.33-.48-.67-.96-.99-1.44l-1.32-3.07 1.89 1.73c.53.49 1.07.97 1.61 1.45.66.8 1.26 1.53 1.86 2.26l3.21 3.87z"
        fill="url(#aK)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M885.3 825.11c-.54-.49-1.08-.97-1.61-1.46l-.14-.2c-.16-.38-.32-.75-.48-1.13l-1.21-2.91 2.3 2.47c.66.84 1.29 1.63 1.93 2.41l-.78.83z"
        fill="url(#aL)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M883.36 822.69L883.06 822.31 881.49 818.51 884.18 821.91 883.36 822.69z"
        fill="url(#aM)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M882.6 813.85l-3.67-4.28-.03-.15c-.21-.97-.4-1.94-.57-2.91l-.43-2.54 3.04 4.52c.25.9.52 1.8.81 2.7l.85 2.66z"
        fill="url(#aN)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M891.9 833.01l-3.6-4.26-1.26-1.5-3.17-3.82 4.83 3.71 3.21 5.87z"
        fill="url(#aO)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M889.94 829.46l-2.91-2.21c-.61-.73-1.21-1.46-1.81-2.2l.78-.83 2.06 1.85.13.16c.16.31.32.61.48.91l1.25 2.32z"
        fill="url(#aP)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M889.74 829.02l-2.37-2.06c-.69-.61-1.38-1.23-2.07-1.85-.7-.86-1.34-1.65-1.97-2.45l.82-.78c1.29 1.39 2.59 2.77 3.91 4.13l.09.12 1.58 2.89z"
        fill="url(#aQ)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M883.47 816.09l-3.82-3.62-.04-.16c-.26-.96-.5-1.92-.71-2.89l-.49-2.22 3.34 3.98c.29.89.59 1.77.9 2.65l.82 2.26zm-2.84-4.26l.22.21-.12-.36-.2-.24c.03.13.07.26.1.39z"
        fill="url(#aR)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M884.43 818.39l-3.94-3.08-.06-.18c-.29-.94-.57-1.88-.83-2.83l-.53-1.97 3.53 3.35.05.13c.32.87.65 1.73.99 2.59l.79 1.97zm-3-3.8l.43.34c-.07-.18-.14-.37-.2-.55l-.42-.39c.06.2.12.4.19.6z"
        fill="url(#aS)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M885.47 820.69l-4.05-2.64-.33-.95c-.23-.65-.44-1.31-.65-1.97l-.55-1.76 3.7 2.9.06.15c.24.59.48 1.18.73 1.76l1.09 2.5zm-3.14-3.42l.62.4c-.09-.21-.17-.43-.26-.64l-.61-.47s.03.1.05.15l.2.56z"
        fill="url(#aT)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M890.01 829.67l-2.73-2.83c-1.32-1.37-2.63-2.75-3.92-4.15l-.33-.45c-.61-1.47-1.17-2.94-1.68-4.37l-.57-1.61 3.84 2.51.07.16c1.08 2.45 2.24 4.88 3.47 7.22l1.85 3.53zm-5.99-7.98l.17.21c.42.45.84.91 1.27 1.36-.59-1.22-1.16-2.45-1.7-3.69l-.77-.5c.33.87.67 1.74 1.04 2.62z"
        fill="url(#aU)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M872.86 781.57l-1.56-4.86c-2.65-8.25-5.4-15.75-8.39-22.95-.86-2.74-1.77-5.43-2.7-8.03-6.45-18.07-15.38-34.67-26.55-49.35-9.05-11.79-19.38-23.35-31.58-35.35l-6.38-6.19-10.93-9.95-8.95-7.72c-1.92-1.65-3.91-3.28-5.83-4.86-1.09-.89-2.18-1.79-3.27-2.69-10.73-8.75-22.62-17.92-37.42-28.88-4.61-3.42-9.24-6.81-13.88-10.21-7.97-5.84-16.22-11.88-24.25-18-.82-.63-1.63-1.26-2.45-1.89-1.5-1.15-2.99-2.3-4.47-3.47l-6.84-5.51c-5.13-4.29-10.57-8.85-15.96-13.44-6.15-5.24-11.17-9.57-15.79-13.61a1970.01 1970.01 0 01-31.16-27.74c-4.06-3.69-8.11-7.4-12.14-11.13-4.86-5.17-9.72-10.44-14.47-15.67-1.03-1.13-2.05-2.26-3.07-3.4l-.15-.17-.03-4.11 17.38 14.07c5.63 5.23 11.22 10.37 16.65 15.3a1968.25 1968.25 0 0031.06 27.65c4.64 4.05 9.64 8.36 15.74 13.56 5.45 4.65 11.05 9.34 15.88 13.38l6.74 5.43c1.46 1.15 2.94 2.29 4.42 3.42.81.62 1.62 1.24 2.42 1.86 7.95 6.06 16.17 12.08 24.13 17.91 4.64 3.4 9.29 6.81 13.92 10.24 14.89 11.02 26.86 20.26 37.66 29.07 1.08.9 2.16 1.79 3.25 2.67 1.96 1.6 3.99 3.26 5.95 4.95l9.05 7.8 13.24 12.19 4.31 4.18c12.42 12.22 22.95 24.01 32.2 36.05 11.61 15.25 20.88 32.47 27.56 51.2.46 1.27.9 2.55 1.33 3.84 2.27 9.31 3.9 19.14 4.86 29.28l.49 5.11z"
        fill="url(#aV)"
      />
      <Path
        d="M555.53 451.4l-1.85-1.79a900.77 900.77 0 00-5.61-5.26l.7-.91 4.28 3.4c1.14 1.28 2.21 2.51 3.27 3.74l-.79.83z"
        fill="url(#aW)"
      />
      <Path
        d="M585.77 477.74l-.96-1.07c-1.08-1.2-2.16-2.4-3.24-3.61l-.13-.14-.34-3.37 4.64 3.76.02 4.44zm-3.26-5.34c.71.8 1.43 1.59 2.14 2.39v-.91l-2.17-1.75.03.26z"
        fill="url(#aX)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M580.46 471.8L578.25 469.32 577.74 466.82 580.36 468.94 580.46 471.8z"
        fill="url(#aY)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M582.71 474.33L579.3 470.51 579.21 468.01 582.33 470.53 582.71 474.33z"
        fill="url(#aZ)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M579.72 470.98L576.31 467.13 577.05 466.26 579.1 467.92 579.72 470.98z"
        fill="url(#ba)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M873.29 789.93l-1.23-2.94c-.71-1.71-1.43-3.41-2.16-5.12l-.04-.13c-1.89-9.88-4.23-19.32-6.97-28.04l1.04-.42c3 7.23 5.76 14.77 8.42 23.05l.03.13c.32 3.36.57 6.81.75 10.26l.16 3.21zm-2.35-8.48c.3.69.6 1.39.89 2.09-.15-2.32-.34-4.63-.55-6.89-1.33-4.12-2.68-8.06-4.07-11.86 1.39 5.37 2.63 10.95 3.73 16.67zM602.36 495.74c-5.77-5.33-11.66-10.82-17.48-16.31l-.18-.17V479c-.02-.91-.02-1.82-.03-2.73v-1.48l.96 1.07 3.07 3.4c4.74 5.23 9.59 10.49 14.42 15.63l-.76.85zm-16.56-17.01c2 1.88 4 3.77 6.01 5.64-1.31-1.43-2.62-2.87-3.92-4.3-.7-.77-1.4-1.55-2.1-2.32 0 .33 0 .65.01.98zm-26.83-24.01l-3.44-3.32c-1.09-1.27-2.16-2.48-3.23-3.7l.75-.86 4.01 3.27c.92 1.27 1.83 2.55 2.73 3.83l-.82.78z"
        fill="url(#bb)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M585.82 480.32l-3.97-3.74-.02-.22c-.14-1.21-.27-2.42-.39-3.63l-.18-1.73 1.13 1.27c1.07 1.2 2.15 2.41 3.23 3.6l.15.17v.23c0 .91.01 1.81.03 2.72l.02 1.33zM582.9 476l1.77 1.67v-1.17c-.65-.72-1.3-1.44-1.94-2.17l.18 1.66z"
        fill="url(#bc)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M580.51 475.51l-1.35-1.91c-.32-1.48-.63-2.95-.94-4.44l-.42-2.07 2.6 2.94v.22c.05 1.18.07 2.35.09 3.53l.02 1.74z"
        fill="url(#bd)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M583.1 477.76l-3.07-2.9-.66-.87v-.2c-.02-1.17-.04-2.34-.08-3.5l-.05-1.56 3.27 3.67.02.2c.12 1.21.25 2.41.39 3.62l.17 1.54zm-2.62-4.18l.36.48.81.76c-.07-.63-.14-1.27-.2-1.9l-1-1.12.03 1.78z"
        fill="url(#be)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M575.5 467.11L574.62 464.3 576.44 465.77 576.58 466.85 575.5 467.11z"
        fill="url(#bf)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M580.8 475.91l-1.54-2.08c-.93-1.25-1.85-2.51-2.77-3.76l-.09-.17-.9-2.79-.33-2.36 1.88 1.52 2.22 2.49.03.16c.3 1.48.61 2.95.93 4.42l.56 2.57zm-3.38-6.48c.39.54.79 1.08 1.18 1.61-.12-.57-.24-1.14-.36-1.72l-1.36-1.54c.17.53.35 1.09.53 1.64z"
        fill="url(#bg)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M577.07 470.86l-1.24-1.71-2.08-2.86-.06-.11-1.81-4.11 4.31 3.49.37 1.18c.11.73.18 1.36.26 1.99l.25 2.13zm-2.1-4.81l.36.5-.09-.27-.27-.22z"
        fill="url(#bh)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M578.55 472.9l-2.82-3.87-.02-.16c-.07-.62-.15-1.25-.23-1.87l1.08-.27c.3.93.59 1.85.89 2.78l1.1 3.39z"
        fill="url(#bi)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M573.97 466.51L569.1 460.02 572.55 462.63 572.58 462.84 573.97 466.51z"
        fill="url(#bj)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M576.86 470.6l-3.11-4.3c-.72-.99-1.44-1.99-2.15-2.98l-.11-.28-.23-1.46 2.52 2.04 3.09 6.99z"
        fill="url(#bk)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M565.16 460.67l-6.2-5.96c-.97-1.36-1.88-2.63-2.79-3.9l-2.53-3.5 7.25 5.91c.78 1.33 1.55 2.67 2.32 4.02l1.95 3.42zm-5.65-7.13l.27.39.48.46c-.09-.15-.18-.3-.26-.45l-.49-.4z"
        fill="url(#bl)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M580.51 475.29L579.27 474.14 578.59 471.03 580.49 473.58 580.51 475.29z"
        fill="url(#bm)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M580.03 474.86L579.38 474.24 579.37 472.08 580.84 474.06 580.03 474.86z"
        fill="url(#bn)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M580.71 475.5l-3.58-3.4-.05-.14c-.23-.69-.45-1.37-.68-2.06l-1.1-3.37 2.06 2.82c.92 1.26 1.84 2.51 2.77 3.76l.1.23.47 2.16z"
        fill="url(#bo)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M577.2 472.17l-1.43-1.45-.21-.36c-.65-1.42-1.26-2.79-1.87-4.17l-2.17-4.9 5.28 7.28.02.16c.07.63.15 1.27.22 1.91l.17 1.54z"
        fill="url(#bp)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M578.85 473.73l-2.9-2.75-.02-.22-.21-1.89-.25-2.13 1.99 2.77c.22.69.45 1.37.68 2.06l.72 2.16z"
        fill="url(#bq)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M573.55 466.93L569.79 460.34 572.52 462.67 572.66 463.17 573.55 466.93z"
        fill="url(#br)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M575.55 470.36c-1.32-2.24-2.62-4.49-3.91-6.74l-.15-.52-.66-2.79 1.64 2.29c.71 1 1.43 1.99 2.15 2.98l.06.11c.61 1.37 1.22 2.74 1.84 4.11l-.97.56z"
        fill="url(#bs)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M567.83 463.24l-5.57-5.39c-.76-1.34-1.53-2.67-2.31-4l-1.59-2.71 6.37 5.15.06.13c.64 1.39 1.27 2.79 1.88 4.19l1.16 2.64zm-4.66-6.06l1.3 1.25-.63-1.38-1.39-1.12c.24.42.48.83.71 1.25z"
        fill="url(#bt)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M578.81 473.66L575.7 470.68 575.52 470.3 576.5 469.74 578.81 473.66z"
        fill="url(#bu)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M570.81 466.09l-5.15-4.99c-.62-1.4-1.24-2.79-1.88-4.17l-1.02-2.22 5.86 4.74.06.16c.5 1.44.98 2.89 1.45 4.34l.69 2.14zm-4.19-5.59l1.74 1.67c-.22-.67-.45-1.33-.67-2l-1.9-1.54c.28.62.56 1.24.83 1.87z"
        fill="url(#bv)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M573.96 469.09l-4.84-4.62-.05-.14c-.47-1.45-.94-2.89-1.44-4.32l-.65-1.88 5.28 4.33.39.73c.32 1.37.63 2.74.92 4.12l.38 1.8zm-3.88-5.29l2.02 1.93c-.16-.73-.33-1.46-.5-2.19l-.23-.4-2.06-1.67c.26.77.51 1.55.76 2.33z"
        fill="url(#bw)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M577.89 472.83l-5.36-5.1-.04-.18c-.29-1.37-.59-2.73-.91-4.09l-.88-3.75 1.89 3.31c1.29 2.25 2.59 4.5 3.9 6.73l1.39 3.09zm-4.35-5.72l.26.25-.33-.57c.02.11.05.21.07.32z"
        fill="url(#bx)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M872.02 794.48l-.46-2.91c-.52-3.32-1.1-6.62-1.71-9.83l-.96-5.05 2.01 4.69c.73 1.71 1.45 3.41 2.17 5.13l.05.2c.04.71.07 1.43.1 2.14v.15l-.57 2.6-.63 2.87zm-.17-7.99c.07.4.14.79.2 1.19-.01-.26-.02-.53-.04-.79-.06-.13-.11-.26-.16-.4z"
        fill="url(#by)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M874.24 776.47l-1.1-4.88c-1.89-8.39-4.13-16.47-6.68-24.02-.6-2.44-1.22-4.81-1.88-7.12a171.842 171.842 0 00-24.78-52.04c-8.75-12.34-18.88-24.34-30.98-36.68l-6.35-6.38c-.44-.44-.9-.86-1.36-1.29l-9.58-8.93-9.01-7.88c-1.93-1.7-3.96-3.36-5.91-4.97-1.09-.9-2.19-1.8-3.27-2.71-11.05-9.05-23.48-18.55-38.01-29.06-6.41-4.65-12.99-9.3-19.35-13.8-6.47-4.58-13.16-9.31-19.71-14.06l-2.37-1.74c-1.46-1.06-2.92-2.13-4.36-3.22l-6.67-5.09-33.28-26.37-33.09-26.58-15.16-12.28c-4.69-4.35-9.33-8.69-13.95-13.06l-2.77-2.62v-.25c-.03-1.11-.07-2.21-.12-3.32l-.05-1.15.91.64c5.27 3.69 10.53 7.4 15.79 11.13l19.23 15.57 38.59 30.95 27.69 21.93 6.58 5.02c1.42 1.07 2.86 2.12 4.3 3.17.79.57 1.58 1.15 2.36 1.73 6.47 4.7 13.13 9.41 19.58 13.96 6.4 4.52 13.01 9.2 19.47 13.89 14.6 10.56 27.13 20.14 38.32 29.29 1.1.92 2.2 1.82 3.3 2.73 1.98 1.63 4.03 3.32 6 5.04l9.12 7.98 9.72 9.06c.47.44.94.88 1.41 1.33l6.45 6.48c12.37 12.62 22.73 24.89 31.67 37.51a178.579 178.579 0 0125.77 54.12c.26.91.52 1.83.76 2.74.36 1.94.67 3.85.93 5.73 1.12 7.82 1.74 15.97 1.85 24.22v5.25z"
        fill="url(#bz)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M585.71 471.18l2.41 2.28c4.62 4.36 9.26 8.71 13.92 13.03l15.13 12.25 33.09 26.58 16.6 13.21 16.65 13.14 6.67 5.09c1.44 1.09 2.89 2.14 4.35 3.2.79.58 1.59 1.15 2.37 1.74 6.54 4.74 13.23 9.47 19.69 14.05 6.37 4.5 12.95 9.16 19.36 13.81 14.54 10.52 26.99 20.04 38.06 29.1 1.09.91 2.18 1.81 3.27 2.7 1.96 1.61 3.99 3.28 5.94 4.99l9.02 7.89 9.59 8.94c.47.43.94.87 1.39 1.32l6.36 6.39c12.15 12.39 22.32 24.43 31.09 36.81a173.167 173.167 0 0124.97 52.42c.66 2.32 1.3 4.71 1.88 7.11 2.01 5.96 3.85 12.29 5.46 18.85-.26-6.43-.83-12.78-1.7-18.92-.26-1.87-.57-3.76-.91-5.64-.23-.86-.49-1.77-.75-2.68a177.268 177.268 0 00-25.59-53.74c-8.92-12.59-19.24-24.81-31.56-37.39l-6.45-6.47c-.45-.44-.92-.87-1.38-1.31l-9.71-9.05-9.11-7.97c-1.96-1.72-4-3.4-5.98-5.02-1.1-.91-2.2-1.81-3.3-2.73-11.16-9.14-23.68-18.71-38.26-29.25-6.46-4.68-13.07-9.36-19.46-13.88-6.44-4.56-13.11-9.27-19.59-13.97-.79-.58-1.57-1.15-2.36-1.72-1.45-1.05-2.89-2.11-4.32-3.18l-6.57-5.01-33.25-26.35-52.27-42.11c-4.92-3.49-9.88-6.99-14.85-10.47l.06 1.94z"
        fill="url(#bA)"
      />
      <Path
        d="M586.16 470.98c2.43 2.22 6.56 6.11 9.02 8.41 2.86 2.61 6.31 6.11 9.27 8.42 32.24 25.65 65.09 53.44 98.46 77.57 50.77 36.11 103.99 72.51 139.87 124.5 11.78 17.28 20.35 37.04 25.21 57.19 2.1 6.21 3.9 12.52 5.47 18.88.02.02-.98.14-.98.15-.49-8.04-1.61-16.45-3.13-24.39-9.24-32.66-27.3-59.52-50.54-84.26-22.61-24.42-48.52-45.41-75.25-65.17-11.68-8.61-28.7-20.6-40.62-29.22-11.98-8.42-27.99-21.54-39.53-30.81-20.59-16.46-42.5-34.75-62.91-51.53-4.24-3.21-11-8.01-15.13-11.06h-.02l.79-.44c.02.59.02 1.17.02 1.76zm-.91.41c-.05-.7-.08-1.42-.1-2.13l-.03-.99.82.56c4.07 2.84 11.73 7.91 15.52 10.65 2.77 2.19 21.31 16.77 24.59 19.35 18.88 14.88 39.93 31.55 59.03 46.38 11.31 8.83 28.66 20.76 40.52 29.25 40.92 28.84 81.76 59.45 112.54 99.43 15.61 19.81 27.29 42.88 33.24 67.38l.02.07v.02l.87 6.16c.98 7.58 1.23 15.31 1.31 22.95-1.9-7.75-3.93-15.52-6.51-23.06-5.84-24.37-16.99-47.34-32.44-67.08-35.61-46.63-84.92-80.45-132.29-114.12-12.06-8.33-28.22-21.3-39.84-30.5-19.81-15.77-41.39-33.07-61.1-49.12-5.06-4.77-11.14-10.34-16.14-15.18z"
        fill="#40a840"
      />
      <Path
        d="M548.1 444.38l-8.45-6.6.62-.97c1.56 1.03 3.12 2.06 4.67 3.1 1.33 1.22 2.59 2.39 3.85 3.57l-.7.91z"
        fill="url(#bB)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M585.75 472.8l-4.8-4.54-.03-.22c-.1-.85-.21-1.71-.32-2.56l-.17-1.29 5.16 3.6v.3c.06 1.12.1 2.23.13 3.35l.03 1.36zm-3.75-5.12l2.56 2.43-.06-1.66-2.63-1.84c.04.36.09.72.13 1.08z"
        fill="url(#bC)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M580.31 467.64l-3.01-2.86-.04-.18c-.12-.56-.25-1.11-.38-1.67l-.33-1.45 3.53 2.46.02.29.12 1.98.08 1.43zm-2.01-3.49l.73.7-.02-.24-.73-.51s0 .04.01.05z"
        fill="url(#bD)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M582.21 469.46l-3.08-2.93v-.24c-.05-.65-.09-1.31-.13-1.96l-.08-1.18 2.75 1.91.03.26.33 2.58.19 1.56zm-2-3.48l.51.49-.09-.73-.45-.32.03.56z"
        fill="url(#bE)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M576.15 463.69L573.67 461.31 572.88 458.94 575.71 460.91 576.15 463.69z"
        fill="url(#bF)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M578.75 466.16l-3.92-3.74-.38-2.4 3.47 2.41.05.22c.13.56.25 1.12.38 1.67l.4 1.82z"
        fill="url(#bG)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M575.38 462.95L572.03 459.75 572.71 458.83 574.41 460 575.38 462.95z"
        fill="url(#bH)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M883.87 826.17L881.7 824.77 881.14 823.3 882.14 822.8 883.87 826.17z"
        fill="url(#bI)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M886.49 827.88l-4.51-2.92-.81-1.59-1.09-2.9 3.58 2.83.33.55c.37.61.74 1.23 1.12 1.83l1.38 2.2zm-3.68-3.76l.05.03-.12-.18.07.14z"
        fill="url(#bJ)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M885.19 825.86l-4.35-3.36-.06-.16c-.26-.71-.51-1.43-.73-2.15l-.6-2 2.78 2.61c.47.83.95 1.66 1.44 2.49l1.52 2.57z"
        fill="url(#bK)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M884.01 823.96l-3.91-3.61-.05-.15-.15-.53c-.14-.42-.27-.87-.41-1.31l-.74-2.44 2.07 2.33c.46.86.93 1.71 1.41 2.56l1.78 3.16z"
        fill="url(#bL)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M883.06 822.44L879.49 818.35 877.73 812.41 883.06 822.44z"
        fill="url(#bM)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M886.71 830.2c-.91-1.35-1.74-2.62-2.52-3.88l-1.38-2.21 3.18 2.07.07.15c.51 1.09 1.04 2.17 1.59 3.25l-.94.62zm-7.35-23.76l-2.64-4.98v-.56l.29-4.7 1.78 4.61c.05.89.13 1.8.23 2.69l.34 2.95z"
        fill="url(#bN)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M886.92 828.16l-2.74-1.84c-.38-.61-.76-1.23-1.13-1.86l-1.82-3.1 3.95 3.04.06.14c.27.6.54 1.2.82 1.79l.86 1.83z"
        fill="url(#bO)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M886.17 826.61l-3.44-2.7c-.49-.83-.97-1.67-1.45-2.51l-1.79-3.17 2.63 2.43c.64.59 1.28 1.18 1.93 1.77l.09.1.6.89 1.43 3.18z"
        fill="url(#bP)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M886.8 826.49l-3.48-3.17c-.65-.59-1.29-1.18-1.93-1.77l-.11-.14c-.48-.85-.96-1.72-1.42-2.58l-2.22-4.15 3.11 3.46c.58.65 1.17 1.3 1.75 1.94.58.88 1.11 1.68 1.64 2.47l2.66 3.96z"
        fill="url(#bQ)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M881.69 820.88c-.59-.65-1.18-1.3-1.76-1.95l-.08-.12-.53-1.03-1.08-3.81 1.83 2.5c.36.49.72.98 1.08 1.46.48.77.94 1.49 1.41 2.21l-.86.74z"
        fill="url(#bR)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M880.27 818.66c-.36-.49-.73-.98-1.09-1.47l-.09-.19-1.2-4.42 2.05 3.4c.4.67.81 1.33 1.23 1.99l-.9.69z"
        fill="url(#bS)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M879.85 808.84l-3.03-4.44v-.17c-.07-.99-.1-1.98-.1-2.93v-2.24l2.3 4.43c.1.91.24 1.86.4 2.82l.43 2.54zm-1.94-4.86l.06.09c-.01-.11-.03-.23-.04-.34l-.04-.08c0 .11.01.22.02.32z"
        fill="url(#bT)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M883.84 824.11L880.55 819.24 884.55 822.97 884.79 823.52 883.84 824.11z"
        fill="url(#bU)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M885.58 825.37l-2.35-2.15c-.54-.8-1.07-1.6-1.59-2.41l.86-.74c.49.54.98 1.07 1.47 1.6l.11.18c.16.37.31.75.47 1.12l1.03 2.4z"
        fill="url(#bV)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M885.25 824.69l-2.08-2.2c-.49-.53-.99-1.07-1.48-1.61-.53-.8-.99-1.53-1.45-2.26l.9-.69c.93 1.24 1.87 2.47 2.82 3.69l.08.14 1.21 2.93z"
        fill="url(#bW)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M880.47 811.37l-3.36-3.94-.02-.18a52.97 52.97 0 01-.28-3.02l-.13-2.04 2.74 4.12c.16.95.35 1.91.56 2.85l.49 2.22zm-2.3-4.45l.29.34c-.04-.21-.08-.42-.11-.62l-.25-.37c.02.22.05.44.07.65z"
        fill="url(#bX)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M881.21 813.96l-3.63-3.47-.03-.19a60.5 60.5 0 01-.45-3.04l-.22-1.86 3.08 3.62.03.15c.21.95.44 1.89.69 2.83l.53 1.97zm-2.6-4.07l.52.49c-.06-.27-.13-.54-.19-.81l-.47-.55c.05.29.09.58.14.87z"
        fill="url(#bY)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M882.04 816.53l-3.84-3.02-.05-.21c-.23-1-.43-2-.61-3.01l-.3-1.71 3.39 3.24.04.16c.25.93.52 1.86.81 2.78l.55 1.76zm-2.86-3.71l.72.57c-.09-.31-.17-.62-.26-.92l-.68-.65c.07.34.14.67.21 1z"
        fill="url(#bZ)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M882.96 819.06l-4.03-2.63-.06-.22c-.26-.97-.5-1.94-.72-2.91l-.36-1.57 3.64 2.87.06.18c.2.65.42 1.29.64 1.93l.84 2.36zm-3.08-3.39l.91.6c-.11-.32-.21-.64-.31-.96l-.88-.69.27 1.05z"
        fill="url(#ca)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M601.33 487.4l-16.68-13.51v-.28c-.01-.71-.03-1.42-.04-2.13l-.03-1.36 3.55 3.36c4.62 4.36 9.26 8.71 13.92 13.03l-.71.9zm-15.58-14.09l3.77 3.05c-.71-.67-1.42-1.34-2.14-2.01l-1.64-1.55v.51zm-33.38-25.54l-4.26-3.39c-1.29-1.2-2.55-2.37-3.81-3.54l.66-.94c1.01.68 2.03 1.36 3.04 2.04l1.8 1.23c1.12 1.24 2.22 2.48 3.32 3.73l-.75.86z"
        fill="url(#cb)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M585.77 474.79l-4.5-3.64-.03-.25c-.1-.96-.21-1.91-.32-2.87l-.19-1.56 4.97 4.71v.25c.02.72.04 1.43.05 2.15l.02 1.21zm-3.45-4.27l2.3 1.86c0-.22 0-.45-.01-.67l-2.4-2.28.12 1.08z"
        fill="url(#cc)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M580.42 470.47l-2.32-1.88-.18-.88c-.21-1.05-.43-2.08-.66-3.11l-.4-1.82 3.36 3.2v.24c.07 1 .12 2 .15 2.99l.05 1.25zm-1.32-2.55l.11.09c-.02-.49-.05-.99-.07-1.48l-.4-.38c.09.43.18.86.27 1.3l.1.48z"
        fill="url(#cd)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M582.49 472.14l-3.22-2.61v-.27c-.05-.99-.09-1.98-.15-2.97l-.08-1.43 2.96 2.82.03.22c.12.96.22 1.92.32 2.89l.14 1.36zm-2.13-3.2l.74.6-.15-1.28-.65-.62.06 1.3z"
        fill="url(#ce)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M576.68 467.55l-1.66-1.96-.5-1.62c-.3-.95-.6-1.88-.9-2.8l-.71-2.16 2.95 2.82.03.2c.19 1.22.37 2.44.54 3.67l.25 1.86z"
        fill="url(#cf)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M579.46 469.69l-3.09-2.5-1.02-1.15-.02-.18c-.16-1.22-.34-2.43-.53-3.64l-.26-1.66 3.77 3.6.04.18c.23 1.03.45 2.07.66 3.11l.46 2.25zm-3.06-4.17l.72.81.62.49c-.14-.68-.29-1.36-.44-2.04l-1.16-1.1c.09.61.18 1.22.26 1.84z"
        fill="url(#cg)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M570.56 458.74L570.65 458.57 570.4 458.66 569.45 456.53 571.14 457.74 570.83 458.22 571.15 457.75 571.33 457.87 571.4 458.1 571.38 458.11 571.41 458.17 571.13 458.31 571.44 458.26 570.68 458.56 570.56 458.74z"
        fill="url(#ch)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M576.88 467.77l-1.73-1.97c-1.07-1.21-2.13-2.42-3.19-3.64l-.1-.15-1.5-3.51-.39-1.5 1.21.76 1.54 1.07 1.91 1.82.05.14c.31.93.61 1.86.9 2.8l1.31 4.19zm-4.05-6.33c.46.53.93 1.06 1.39 1.59-.18-.58-.37-1.15-.56-1.72l-1.52-1.45.68 1.58z"
        fill="url(#ci)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M572.62 462.92l-1.51-1.73c-.78-.89-1.56-1.79-2.34-2.68l-.07-.1-2.13-3.83 4.69 3.24.16.35c.24.88.44 1.68.64 2.48l.56 2.27zm-2.27-4.33s.03.04.05.06v-.03l-.05-.03z"
        fill="url(#cj)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M574.3 464.86l-3.29-3.77-.03-.14c-.2-.79-.4-1.58-.61-2.38l1.04-.4 2.89 6.69z"
        fill="url(#ck)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M572.38 462.67L563.62 452.56 568.66 456.02 572.38 462.67z"
        fill="url(#cl)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M559.58 453.6l-7.22-5.84c-1.17-1.31-2.27-2.55-3.38-3.79l-3.15-3.5 3.85 2.6c1.44.97 2.88 1.95 4.32 2.92l.14.13c.98 1.32 1.95 2.64 2.91 3.97l2.53 3.5zm-6.71-6.98l.24.27.46.36-.24-.33c-.15-.1-.3-.21-.46-.31z"
        fill="url(#cm)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M576.65 467.43L575.24 466.27 574.2 463.03 576.4 465.52 576.65 467.43z"
        fill="url(#cn)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M576.38 467.19L575.4 466.4 575.07 464 577.12 466.33 576.38 467.19z"
        fill="url(#co)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M576.82 467.55l-3.95-3.19-2.46-5.68 2.35 2.7 3.19 3.64.12.21.75 2.33z"
        fill="url(#cp)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M572.99 464.58l-1.42-1.3-.56-.79c-.79-1.39-1.55-2.73-2.3-4.07l-2.7-4.83 3.59 4.13c.78.89 1.55 1.79 2.33 2.68l.09.11.03.14c.18.71.35 1.43.52 2.14l.42 1.78z"
        fill="url(#cq)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M574.77 465.9l-3.23-2.62-.05-.2-.51-2.13-.56-2.28 2.45 2.86 1.9 4.37z"
        fill="url(#cr)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M571 462.49c-1.62-2.26-3.23-4.54-4.83-6.82L564.3 453l3.07 2.16 2.29 2.66c.75 1.34 1.51 2.68 2.27 4.01l-.92.65z"
        fill="url(#cs)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M562.48 455.95l-6.31-5.13c-.96-1.33-1.93-2.65-2.91-3.96l-2.04-2.74 7.18 4.95c.84 1.38 1.66 2.77 2.48 4.17l1.59 2.72zm-5.47-5.91l1.31 1.06c-.26-.44-.52-.87-.79-1.31l-1.39-.95c.29.4.58.79.87 1.19z"
        fill="url(#ct)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M574.96 466.05L571.32 463.05 570.97 462.44 571.89 461.78 574.96 466.05z"
        fill="url(#cu)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M565.81 458.64l-5.86-4.79c-.81-1.39-1.64-2.78-2.47-4.16l-1.37-2.27 6.56 4.48.07.14c.7 1.45 1.38 2.91 2.06 4.37l1.02 2.23zm-4.97-5.5l1.9 1.54c-.31-.66-.62-1.31-.94-1.96l-2.04-1.4c.36.61.72 1.21 1.07 1.82z"
        fill="url(#cv)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M569.33 461.49l-5.49-4.44-.06-.13c-.67-1.46-1.35-2.91-2.05-4.35l-.94-1.95 6.2 4.25.06.18c.56 1.51 1.09 3.02 1.62 4.54l.65 1.89zm-4.6-5.2l2.25 1.82c-.29-.82-.58-1.63-.88-2.45l-2.44-1.67c.36.77.72 1.53 1.07 2.3z"
        fill="url(#cw)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M573.78 465.09l-6.09-4.92-.06-.16c-.52-1.51-1.06-3.02-1.61-4.52l-.62-1.67 1.65 1.15c1.6 2.28 3.21 4.55 4.83 6.81l1.89 3.31zm-5.15-5.64l.49.4c-.23-.33-.46-.65-.69-.98.07.19.13.38.2.58z"
        fill="url(#cx)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M873.83 784.89l-.93-3.04c-.53-1.72-1.06-3.43-1.61-5.14l-.03-.13c-.96-10.08-2.58-19.85-4.81-29.05l1.06-.34c2.56 7.59 4.82 15.71 6.71 24.14l.02.14c0 3.36-.08 6.8-.25 10.24l-.15 3.19zm-1.47-8.5c.22.68.43 1.35.64 2.03.08-2.32.12-4.63.12-6.89-.94-4.19-1.97-8.3-3.09-12.3.99 5.59 1.77 11.33 2.33 17.17z"
        fill="url(#cy)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M873.11 789.51l-1.1-2.73c-.18-3.43-.43-6.86-.74-10.2l-.49-5.11 1.56 4.86c.55 1.72 1.09 3.44 1.62 5.16l.03.1v.11c-.08 1.61-.18 3.23-.29 4.84l-.59 2.98zm-.32-8.02c.02.25.04.5.05.76 0-.17.02-.33.02-.5-.03-.09-.05-.17-.08-.26z"
        fill="url(#cz)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M872.3 793.38l-.19-4.47c-.03-.71-.06-1.42-.1-2.13l-.16-3.23 1.66 4-1.21 5.83z"
        fill="url(#cA)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M876.08 771.31l-.73-5.23c-1.18-8.44-2.85-16.68-4.96-24.49-1.06-5.8-2.47-11.63-4.33-17.88-4.24-14.4-11-28.95-20.09-43.24-8.39-12.83-18.28-25.21-30.22-37.86l-4.85-5.03c-1.16-1.21-2.36-2.46-3.6-3.6l-8.76-8.36-9.03-8.01c-1.61-1.47-3.29-2.86-4.57-3.91l-4.65-3.86c-11.39-9.38-23.96-18.91-38.42-29.15-8.47-6.01-17.21-11.95-25.67-17.7-4.72-3.21-9.45-6.42-14.16-9.67l-8.21-5.75-5.5-3.97-34.91-25.72c-12.34-9.03-23.81-17.35-35.06-25.43-5.93-4.26-11.87-8.5-17.82-12.72l-16.1-13.03v-.27c-.08-1.25-.16-2.49-.25-3.73l-.08-1.11 1.62.98c1.85 1.13 3.7 2.25 5.55 3.36 2.9 1.75 5.8 3.51 8.69 5.29 7.13 5.04 14.51 10.3 21.98 15.67 11.17 8.02 22.65 16.35 35.11 25.46l41.66 30.59 6.82 4.75c4.68 3.22 9.38 6.42 14.09 9.62 8.49 5.77 17.26 11.74 25.79 17.79 14.59 10.32 27.28 19.95 38.8 29.43l4.7 3.9c1.3 1.07 3.01 2.49 4.66 3.99l9.15 8.12 8.9 8.49c1.28 1.18 2.51 2.46 3.7 3.7l4.93 5.11c12.23 12.95 22.36 25.65 30.98 38.82 9.45 14.84 16.48 29.98 20.91 45.01 1.31 4.39 2.43 8.71 3.35 12.86.13.94.25 1.84.36 2.74.65 5.85.99 11.86 1.03 17.88-.02 3.58-.16 7.25-.42 10.89l-.37 5.27z"
        fill="url(#cB)"
      />
      <Path
        d="M876.1 771.8c-1.45-5-1.77-10.31-2.84-15.37-.93-4.95-2.04-9.86-3.35-14.72-1.53-8.3-3.72-16.48-6.45-24.46-11.05-32.07-32.66-59.24-56.48-82.88-31.69-31.14-68.9-55.86-105.46-80.81-25.42-17.91-51.62-37.92-76.9-55.95-8.1-5.91-16.33-11.7-24.48-17.55l-1.23-1-4.93-3.99-9.86-7.98-.17-.14v-.22l-.35-5.08-.07-.97.83.49c6.58 3.95 15.66 8.95 21.68 13.45 30.99 21.56 62.65 44.64 93.24 66.88 17.29 11.93 35.34 23.97 52.52 36.13 38.04 27.21 74.57 58.16 100.38 97.63 11.49 18.05 20.04 38.06 24.32 59.05.79 6.18 1.09 12.38 1.14 18.58.06 2.97-.25 6.37-.37 9.25-.11 3.13-.42 6.61-1.17 9.67zm-.03-1c-.01-1.47-.29-2.81-.23-4.22l.11-4.51.11-4.59.06-2.29c-.14-6.86-.62-13.77-1.64-20.53-1.9-7.8-4.36-16.38-7.43-24.11-13.18-33.55-36.88-61.81-62.91-86.26-18.55-17.39-38.71-32.97-59.43-47.71-15.15-10.58-32.07-22.03-47.16-32.67-22.6-16.81-49.04-36.36-71.77-53.05-6.83-5.06-13.73-9.99-20.59-14.99l-5.16-3.74c-1.76-1.18-3.58-2.26-5.37-3.4L583.84 462l.76-.47.33 5.12-.18-.36 9.85 7.97c1.26 1.02 5.09 4.13 6.15 4.98 8.15 5.85 16.36 11.62 24.46 17.54 23.45 16.77 48.22 35.44 71.69 52.3 10.31 7.24 21 14.38 31.33 21.57 48.02 32.95 97.65 70.95 126 122.97 7.96 14.9 13.64 31.35 16.66 47.81 1.32 4.89 2.44 9.83 3.37 14.8.82 4.85 1.92 9.62 1.82 14.55z"
        fill="#40a840"
      />
      <Path
        d="M539.69 437.8c-2.46-1.62-4.93-3.23-7.4-4.83l.55-1.02 4.18 2.3 3.3 2.58-.62.97z"
        fill="url(#cC)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M585.58 467.64l-5.28-4.27-.03-.23c-.15-1.01-.31-2.03-.47-3.04l-.2-1.23 1.31.8c1.36.83 2.73 1.66 4.09 2.48l.25.15.02.31c.09 1.25.17 2.51.24 3.76l.07 1.27zm-4.25-4.91l3 2.43c-.04-.72-.09-1.43-.14-2.15-1.03-.62-2.07-1.25-3.1-1.88l.24 1.6z"
        fill="url(#cD)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M580.04 463.15l-3.84-3.1-.05-.19c-.19-.76-.38-1.52-.57-2.27l-.35-1.37 4.44 2.69.03.3c.09.87.17 1.75.24 2.62l.11 1.32zm-2.86-3.79l1.53 1.23-.09-.98-1.62-.98.18.72z"
        fill="url(#cE)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M581.58 464.4l-2.74-2.22-.02-.26c-.07-.87-.15-1.74-.24-2.6l-.11-1.14 2.38 1.45.04.27c.17 1.02.33 2.04.47 3.06l.21 1.44zm-1.68-2.83l.15.12-.21-1.32-.05-.03c.04.41.07.82.11 1.23z"
        fill="url(#cF)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M575.47 459.46l-3.36-2.72-1.09-3.04 1.34.8c.75.45 1.5.89 2.24 1.34l.22.13.05.26c.11.57.22 1.14.32 1.71l.27 1.51z"
        fill="url(#cG)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M577.63 461.2l-3.48-2.82-.04-.22c-.1-.57-.21-1.13-.32-1.7l-.24-1.27 3.04 1.84.06.23c.2.76.39 1.52.58 2.28l.41 1.65zm-2.47-3.48l.58.47c-.03-.13-.07-.25-.1-.38l-.52-.31c.01.08.03.15.04.23z"
        fill="url(#cH)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M570.71 455.52L569.37 454.52 568.04 453.44 567.11 451.42 570.02 453.1 570.71 455.52z"
        fill="url(#cI)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M573.78 458.08l-4.54-3.67-.6-2.04 1.22.64c.84.49 1.68.99 2.51 1.49l.17.1 1.24 3.48z"
        fill="url(#cJ)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M570.01 455.03L567.38 452.91 567.99 451.93 568.79 452.39 570.01 455.03z"
        fill="url(#cK)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M600.52 479.73c-5.25-3.73-10.51-7.43-15.78-11.12l-.24-.16v-.3c-.04-.57-.06-1.14-.09-1.72l-.07-1.28 16.83 13.63-.65.95zm-14.93-11.94c.48.33.95.67 1.43 1l-1.44-1.16v.16zm-41.22-26.9c-1.55-1.04-3.11-2.07-4.67-3.09l-3.26-2.56.59-.99.73.4c.95.53 1.91 1.05 2.87 1.57l.9.51c1.17 1.07 2.33 2.14 3.5 3.21l-.66.94z"
        fill="url(#cL)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M585.65 469.24l-5.01-3.51-.03-.26c-.11-.78-.21-1.56-.33-2.34l-.21-1.44 5.44 4.4v.27c.04.58.07 1.15.1 1.73l.05 1.15zm-3.98-4.19l2.77 1.94c0-.1 0-.19-.01-.29l-2.85-2.3.09.66z"
        fill="url(#cM)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M580.19 465.43l-3.25-2.26-.05-.22c-.24-1.03-.48-2.06-.73-3.09l-.4-1.65 4.16 3.36.02.26c.07.81.13 1.61.18 2.42l.08 1.19zm-2.27-2.99l1 .7c-.02-.32-.05-.64-.07-.96l-1.22-.99c.1.42.2.83.29 1.25z"
        fill="url(#cN)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M581.87 466.6l-2.86-1.99-.02-.29c-.05-.8-.11-1.6-.18-2.4l-.11-1.33 2.62 2.13.03.23c.12.79.23 1.57.33 2.36l.17 1.29zm-1.79-2.65l.34.23-.12-.82-.28-.22.06.81z"
        fill="url(#cO)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M575.97 462.49l-2.48-1.72-.06-.19c-.44-1.34-.9-2.67-1.36-4l-.67-1.91 3.77 3.06.04.22c.19 1.07.38 2.14.55 3.22l.22 1.33zm-1.56-2.49l.03.02c-.09-.55-.19-1.09-.29-1.64l-.39-.32c.22.65.44 1.29.65 1.94z"
        fill="url(#cP)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M578.3 464.11l-3.6-2.5-.04-.25c-.17-1.07-.35-2.13-.55-3.19l-.28-1.51 3.35 2.71.05.2c.25 1.03.5 2.07.74 3.11l.33 1.45zm-2.59-3.2l.83.58c-.11-.48-.23-.96-.35-1.45l-.73-.59c.08.49.17.97.25 1.46z"
        fill="url(#cQ)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M571.77 459.48l-1.78-1.75a351.7 351.7 0 00-2.01-4.42l-1.05-2.24 3.26 2.63.05.18c.35 1.22.68 2.44 1.01 3.66l.51 1.94z"
        fill="url(#cR)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M575.01 461.82l-2.91-2.02-1.87-1.79-.04-.16c-.32-1.22-.66-2.43-1-3.63l-.5-1.74 4.36 3.53.06.16c.47 1.34.93 2.68 1.37 4.02l.54 1.63zm-3.8-4.44l1.67 1.57c-.25-.74-.51-1.48-.76-2.21l-1.38-1.12.48 1.76z"
        fill="url(#cS)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M572.18 459.89l-5.8-5.6c-.59-1.03-1.18-2.05-1.78-3.07l-1.1-1.89 4.49 2.59.93.75.06.12c.69 1.47 1.36 2.95 2.02 4.44l1.18 2.65zm-4.89-6.28l1.49 1.43c-.25-.54-.49-1.07-.74-1.61l-.66-.53-.75-.43c.22.38.44.76.65 1.14z"
        fill="url(#cT)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M567.05 454.97l-4.15-4-2.42-3.39 4.79 2.77.07.19c.27.68.53 1.36.79 2.04l.91 2.39z"
        fill="url(#cU)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M569.31 457.15l-4.2-4.13c-.26-.68-.52-1.35-.79-2.03l-.61-1.54 1.39.8-.27.51.33-.48.31.18.08.13c.6 1.02 1.19 2.05 1.78 3.08l1.98 3.46z"
        fill="url(#cV)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M562.9 450.97L557.75 446.01 562.91 449.05 563.72 450.19 562.9 450.97z"
        fill="url(#cW)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M874.91 779.96l-.65-3.16c-.36-1.74-.73-3.47-1.12-5.2l-.02-.37c-.11-8.19-.73-16.29-1.84-24.06-.26-1.87-.57-3.76-.91-5.64l1.08-.27c2.12 7.86 3.8 16.15 4.99 24.64v.13c-.18 2.67-.44 5.42-.76 8.17l-.33 2.55-.44 3.2zm-.67-8.57c.15.65.29 1.29.43 1.94.27-2.46.5-4.92.67-7.32-.59-4.23-1.31-8.42-2.14-12.52.61 5.79.96 11.73 1.05 17.72v.17z"
        fill="url(#cX)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M552.93 446.66l-5.52-3.72c-1.03-.69-2.04-1.37-3.05-2.04-1.23-1.13-2.39-2.2-3.56-3.26l-3.57-3.26 4.19 2.3c1.48.81 2.96 1.62 4.42 2.46l.62.38c1.12 1.21 2.23 2.43 3.33 3.66l3.14 3.49zm-7.53-6.45c.13.08.25.17.38.25-.02-.02-.04-.05-.06-.07l-.32-.18z"
        fill="url(#cY)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M571.79 459.57L570.43 458.65 570.22 458.26 568.81 455.1 571.21 457.38 571.79 459.57z"
        fill="url(#cZ)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M572.1 459.81L570.39 458.62 569.66 455.89 572.78 458.88 572.1 459.81z"
        fill="url(#da)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M572.15 459.84l-4.32-2.98-.18-.32-1.27-2.24-1.97-3.45 6.59 6.39 1.15 2.6z"
        fill="url(#db)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M568.03 457.68l-2.43-2.83-1.41-2.01c-.46-.66-.92-1.31-1.37-1.95l.82-.78 2.49 2.48c.27.71.54 1.42.8 2.13l1.09 2.96z"
        fill="url(#dc)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M569.92 458.29l-3.36-2.34-.65-.81c-.26-.71-.53-1.42-.8-2.12l-.91-2.38 3.14 3.05c.43.74.85 1.49 1.27 2.23l1.32 2.37z"
        fill="url(#dd)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M565.6 454.85c-1.63-1.89-3.26-3.79-4.88-5.69l-2.44-2.83 3.63 2.1 1.74 1.68c.53.73.98 1.38 1.43 2.03l1.38 1.98-.86.74z"
        fill="url(#de)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M568.5 458.99L565.57 454.81 566.42 454.06 566.94 454.71 568.5 458.99z"
        fill="url(#df)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M570.33 458.58L566.18 455.67 565.99 455.37 564.75 452.14 570.33 458.58z"
        fill="url(#dg)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M559.78 451.33l-6.52-4.47c-.95-1.28-1.91-2.55-2.88-3.82l-1.77-2.31 7.24 4.19.08.12c.84 1.34 1.66 2.68 2.48 4.02l1.37 2.27zm-5.7-5.27l2 1.36c-.33-.54-.67-1.07-1-1.61l-2.09-1.21c.37.49.73.97 1.09 1.46z"
        fill="url(#dh)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M563.67 453.99l-6.19-4.3c-.81-1.34-1.63-2.68-2.47-4.01l-1.23-1.97 6.78 3.92.08.15c.71 1.41 1.41 2.84 2.1 4.26l.94 1.95zm-5.32-5.04l2.44 1.67c-.35-.71-.71-1.43-1.06-2.14l-2.57-1.49c.4.65.8 1.3 1.19 1.95z"
        fill="url(#di)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M567.64 456.72l-5.83-4.01-.07-.14c-.69-1.42-1.38-2.84-2.09-4.24l-.87-1.73 2.53 1.5.22.26c1.64 1.92 3.26 3.81 4.9 5.7l.64 1.01.57 1.65zm-4.97-4.82l.99.68c-.5-.58-1.01-1.17-1.51-1.76.18.36.35.72.53 1.09z"
        fill="url(#dj)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M568.94 457.57L566.16 455.71 566.02 455.47 564.36 451.16 568.94 457.57z"
        fill="url(#dk)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M873.95 785.33l-1.08-3.58v-.11c.17-3.42.25-6.85.25-10.18v-5l1.1 4.86c.39 1.74.76 3.48 1.12 5.22l.02.1v.11c-.3 2.03-.63 4.14-1.01 6.27l-.4 2.3zm.23-8.93c0 .29-.01.58-.02.86.03-.19.06-.38.08-.58l-.06-.29z"
        fill="url(#dl)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M873.69 786.61l-1.1-.16c.11-1.6.21-3.21.29-4.81l.15-3.19 1.35 4.43-.03.15c-.21 1.2-.43 2.39-.67 3.58z"
        fill="url(#dm)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M881.41 824.59l-3.23-2.11-.21-.66c-.11-.38-.2-.75-.29-1.12l-.66-2.65 2.22 1.75.18.31.15.35c.34.78.68 1.56 1.03 2.33l.82 1.81z"
        fill="url(#dn)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M880.22 822.03l-2.75-2.15-1.18-4.69 1.86 1.77.05.13c.37.98.76 1.95 1.16 2.91l.85 2.03z"
        fill="url(#do)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M879.09 819.42l-2.28-2.15-.16-.63c-.08-.39-.15-.76-.22-1.12l1.06-.32c.23.64.46 1.26.7 1.89l.89 2.33z"
        fill="url(#dp)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M883.28 825.8l-3.62-2.36-.07-.15c-.35-.78-.7-1.57-1.04-2.36l-1-2.39 1.65 1.22 2.38 1.93 1.1 2.47.62 1.64zm-2.76-3.17l.4.26-.27-.53-.39-.3c.09.19.17.38.26.57z"
        fill="url(#dq)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M882.7 823.95l-4.29-3.34-.06-.14c-.41-.98-.8-1.96-1.18-2.95l-.91-2.4 1.96 1.9c.64.61 1.28 1.2 1.91 1.79l.13.18c.42.91.86 1.8 1.31 2.69l1.13 2.26zm-3.39-4.1l.19.15c-.06-.13-.12-.25-.18-.38-.06-.05-.12-.11-.17-.16.05.13.11.26.16.39z"
        fill="url(#dr)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M881.52 821.68l-2.12-1.98c-.63-.59-1.27-1.19-1.9-1.79l-.32-.39c-.24-.64-.48-1.27-.7-1.92l-.54-2.99 1.56 1.82c.48.56.95 1.1 1.43 1.63l.1.15c.4.93.82 1.86 1.25 2.78l1.26 2.68z"
        fill="url(#ds)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M879.14 816.56l-2.84-1.86-.04-.26c-.11-.64-.21-1.28-.3-1.92l-.35-2.38 2.24 3.25c.19.48.39.96.58 1.44l.72 1.73z"
        fill="url(#dt)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M880.45 819.55l-2.36-2.69c-.47-.54-.95-1.08-1.42-1.63l-.36-.42-.3-1.67 2.33 1.53.07.17c.19.46.39.93.59 1.38l1.44 3.33z"
        fill="url(#du)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M877.69 813.08L875.82 811.63 875.09 805.9 877.69 813.08z"
        fill="url(#dv)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M879.6 817.84l-3.64-5.18-.02-.14c-.05-.38-.11-.75-.16-1.13l-.18-1.4 1.34 1.06.06.16c.27.73.54 1.46.83 2.18l1.77 4.45z"
        fill="url(#dw)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M877.81 801.27l-1.88-4.75.5-2.7.48-2.19.59 2.16.6 2.22.03.11v.12l-.58.06.55.06-.3 4.91z"
        fill="url(#dx)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M881.17 823.36L879.47 820.01 881.7 821.71 881.82 821.92 882.17 822.86 881.17 823.36z"
        fill="url(#dy)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M882.51 823.8l-1.86-1.44-.06-.12c-.45-.9-.89-1.81-1.32-2.72l-1.25-2.68 3.05 2.85.05.15c.21.7.45 1.39.71 2.08l.7 1.88z"
        fill="url(#dz)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M881.72 821.86l-2.45-2.34c-.44-.93-.86-1.86-1.27-2.81l-1.44-3.32 2.35 2.67c.5.57 1.01 1.14 1.51 1.71l.12.22c.14.44.27.88.41 1.32.05.19.1.36.15.52l.61 2.02z"
        fill="url(#dA)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M881 817.78l-3.53-2.31-.07-.17c-.2-.48-.4-.97-.59-1.46l-1.77-4.48 2.73 3.9c.47.67.94 1.33 1.41 1.99l1.82 2.52z"
        fill="url(#dB)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M881.29 820.46l-1.68-1.88c-.51-.57-1.01-1.14-1.52-1.71l-.1-.15c-.2-.47-.4-.93-.59-1.4l-.72-1.74 2.58 1.81.19.27c.32.62.6 1.15.88 1.69l.04.11.91 3.02z"
        fill="url(#dC)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M878.67 813.89L876.03 811.79 875.74 810.94 875.41 808.12 878.67 813.89z"
        fill="url(#dD)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M880.3 817.29l-2-1.33c-.48-.66-.95-1.33-1.42-2l-.07-.12c-.29-.73-.57-1.47-.84-2.21l-.7-1.91 1.97 1.62c.29.52.59 1.04.89 1.56.42.87.82 1.7 1.23 2.51l.94 1.87z"
        fill="url(#dE)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M878.58 816.36L876.43 813.38 879.28 815.28 879.51 815.72 878.58 816.36z"
        fill="url(#dF)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M878.51 813.77l-2.23-1.83-.56-1.11-.5-4.47 1.46 3.36c.27.63.55 1.25.83 1.87l.99 2.18z"
        fill="url(#dG)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M877.18 813.52c-.3-.52-.6-1.05-.89-1.57l-1.44-2.56 2.61 2.08.06.13c.21.45.42.91.63 1.36l-.97.57z"
        fill="url(#dH)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M877.83 803.55l-2.29-4.31.08-.93.69-3.87 1.66 4.19-.14 2.67v2.25zm-1.15-4.57l.14.27.02-.42-.13-.34-.04.49z"
        fill="url(#dI)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M881.98 822.89l-2.61-5c-.28-.54-.56-1.08-.83-1.62l.93-.63.7 1.02 1.82 6.23z"
        fill="url(#dJ)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M881.04 817.81l-2.6-1.7-.07-.14c-.41-.83-.82-1.66-1.22-2.5l.97-.57c.53.92 1.07 1.83 1.61 2.74l1.3 2.16z"
        fill="url(#dK)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M881.02 819.71L878.38 815.97 877.39 814.04 879.74 815.65 880.01 816.14 881.02 819.71z"
        fill="url(#dL)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M878.05 806.19l-2.74-4.02.4-5.01 2.12 3.99v.15c0 .93.03 1.89.09 2.85l.13 2.04zm-1.6-4.36l.28.41v-.8l-.21-.39-.06.78z"
        fill="url(#dM)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M878.42 808.97l-3.13-3.68v-.21c-.03-.84-.03-1.68-.02-2.52l.17-2.19 2.46 3.61v.17c.07.97.16 1.96.28 2.95l.23 1.87zm-2.03-4.14l.51.6c-.03-.35-.06-.69-.08-1.03l-.45-.66c0 .36 0 .72.01 1.09z"
        fill="url(#dN)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M878.94 811.79l-3.46-3.32-.02-.23c-.09-1.07-.14-2.14-.17-3.17l-.04-1.6 2.93 3.45.02.18c.12.96.27 1.97.44 2.98l.3 1.71zm-2.39-3.87l.73.7c-.06-.4-.11-.79-.16-1.18l-.65-.76c.02.41.05.83.08 1.25z"
        fill="url(#dO)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M879.59 814.6l-3.01-2.37-.06-.13c-.29-.63-.57-1.26-.84-1.89l-.05-.18c-.06-.6-.12-1.19-.17-1.79l-.12-1.49 3.26 3.13.03.19c.17.99.37 1.97.59 2.95l.36 1.57zm-2.13-3.14l.36.28-.24-1.26-.87-.84c0 .05 0 .1.02.15.24.56.49 1.11.74 1.66z"
        fill="url(#dP)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M880.34 817.37l-1.54-1.09c-.55-.91-1.09-1.83-1.63-2.76-.24-.5-.45-.95-.66-1.41l-.99-2.17 3.66 2.89.05.21c.22.96.45 1.91.71 2.86l.4 1.48z"
        fill="url(#dQ)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M881.09 820.05L877.48 814.07 879.57 815.47 879.28 815.96 879.63 815.51 879.82 815.63 880.01 816.13 881.09 820.05z"
        fill="url(#dR)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M878.92 787.38l-1.1-.16c.39-5.42.58-10.82.58-16.04-.12-8.47-.76-16.84-1.9-24.86-.53-3.75-1.23-7.63-2.09-11.52-.68-4.95-1.61-9.93-2.76-14.85a163.78 163.78 0 00-11.92-33.24c-9.38-19.43-23.05-38.65-40.61-57.13-14.57-15.32-31.82-30.33-52.73-45.88-18.03-13.41-37.19-25.85-55.73-37.88l-2.12-1.38c-4.74-3.1-9.8-6.43-14.73-9.86l-30.64-21.01c-6.59-4.43-13.34-8.88-19.87-13.18-3.69-2.43-7.38-4.86-11.06-7.3-2.44-1.63-4.96-3.23-7.39-4.77l-25.44-16.09c-4.49-3.17-8.96-6.32-13.44-9.45l-1.88-1.31-.02-.28c-.15-1.8-.33-3.57-.53-5.28l-.14-1.16.96.59c1.33.81 2.65 1.61 3.98 2.41 1.86 1.14 3.73 2.26 5.59 3.39 3.38 2.04 6.86 4.15 10.27 6.27l23.89 15.13c2.47 1.56 5.01 3.17 7.48 4.82 3.64 2.41 7.28 4.81 10.93 7.21 6.6 4.34 13.42 8.84 20.09 13.32l30.7 21.05c4.57 3.18 9.13 6.2 14.59 9.77l2.2 1.43c18.57 12.06 37.77 24.52 55.96 38.05 21.22 15.77 38.74 31.02 53.57 46.62 18.3 19.25 31.97 38.5 41.79 58.84a170.25 170.25 0 0112.43 34.66c1.42 6.08 2.51 12.23 3.24 18.28.68 6.09 1.03 12.33 1.07 18.56-.04 6.45-.45 13.09-1.22 19.76-.49 4.02-1.14 8.1-1.99 12.47z"
        fill="url(#dS)"
      />
      <Path
        d="M585.13 460.81l1.43 1c4.48 3.13 8.95 6.28 13.41 9.43l5.9 3.72 19.52 12.37c2.44 1.54 4.97 3.14 7.42 4.78 3.68 2.44 7.37 4.87 11.06 7.3 6.53 4.3 13.28 8.75 19.88 13.18l30.63 21c4.94 3.43 9.99 6.77 14.72 9.86l2.12 1.38c18.55 12.04 37.73 24.49 55.78 37.92 20.97 15.59 38.26 30.64 52.88 46 17.65 18.57 31.38 37.89 40.82 57.43 5.2 10.7 9.24 21.97 12.01 33.49a164 164 0 012.77 14.92c.86 3.88 1.57 7.79 2.1 11.57 1.15 8.07 1.8 16.49 1.92 25.03 0 2.17-.03 4.37-.09 6.59.14-1 .27-2 .39-3 .77-6.62 1.18-13.22 1.22-19.61-.03-6.18-.39-12.38-1.06-18.42-.72-6-1.81-12.1-3.21-18.14a168.613 168.613 0 00-12.34-34.41c-9.77-20.23-23.38-39.38-41.59-58.54-14.79-15.55-32.26-30.76-53.42-46.49-18.16-13.51-37.34-25.96-55.9-38.01l-2.2-1.43c-5.47-3.57-10.04-6.6-14.6-9.77l-30.71-21.06c-6.66-4.48-13.48-8.97-20.08-13.31-3.65-2.4-7.29-4.8-10.93-7.21-2.46-1.65-5-3.26-7.46-4.81l-23.89-15.13c-3.4-2.12-6.88-4.22-10.25-6.26-1.87-1.13-3.73-2.26-5.6-3.39-1.01-.61-2.02-1.22-3.02-1.83.14 1.26.26 2.56.38 3.87z"
        fill="url(#dT)"
      />
      <Path
        d="M585.26 462.3l-5.77-4.02-.04-.25c-.3-1.73-.64-3.46-.99-5.15l-.27-1.29 6.4 3.89.03.29c.2 1.71.38 3.5.53 5.31l.1 1.21zm-4.76-4.72l3.45 2.4c-.12-1.28-.25-2.55-.39-3.77l-3.75-2.28c.24 1.21.47 2.43.69 3.65z"
        fill="url(#dU)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M579.61 458.36l-4.69-3.25-.06-.21c-.46-1.67-.94-3.34-1.44-4.99l-.43-1.42 1.23.73c1.45.86 2.9 1.73 4.35 2.61l.23.14.04.28c.23 1.58.44 3.22.62 4.86l.14 1.25zm-3.73-3.99l2.35 1.63c-.13-1.11-.28-2.21-.43-3.29-.96-.58-1.92-1.16-2.88-1.73.33 1.13.65 2.26.97 3.4z"
        fill="url(#dV)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M580.78 459.18l-2.38-1.66-.03-.27c-.18-1.63-.39-3.26-.62-4.82l-.17-1.2 1.92 1.16.05.25c.35 1.7.69 3.45.99 5.19l.24 1.35z"
        fill="url(#dW)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M574.63 454.91l-4.24-2.93-.07-.17c-.6-1.59-1.22-3.17-1.86-4.75l-.63-1.56 5.4 3.13.06.24c.37 1.53.72 3.08 1.04 4.63l.3 1.41zm-3.34-3.71l1.66 1.14c-.21-.98-.44-1.96-.67-2.94l-2.16-1.25c.4 1.01.79 2.03 1.18 3.05z"
        fill="url(#dX)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M576.35 456.1l-3.06-2.11-.05-.23c-.32-1.54-.67-3.07-1.03-4.59l-.32-1.32 2.53 1.49.07.22c.5 1.67.99 3.34 1.45 5.03l.42 1.52zm-2.07-2.83l.16.11c-.18-.65-.37-1.29-.56-1.94.14.61.27 1.22.4 1.83z"
        fill="url(#dY)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M569.51 451.38l-3.66-2.51-.07-.14c-.73-1.5-1.48-2.99-2.24-4.47l-.9-1.75 4.91 2.84.07.21c.48 1.41.94 2.82 1.38 4.24l.5 1.59zm-2.8-3.33l.75.51c-.26-.8-.52-1.61-.8-2.41l-1.25-.72c.44.87.87 1.74 1.3 2.61z"
        fill="url(#dZ)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M572 453.09l-3.98-2.74-.06-.2c-.44-1.41-.9-2.81-1.37-4.21l-.49-1.45 3.31 1.92.08.19c.64 1.58 1.26 3.17 1.87 4.77l.65 1.72zm-3.04-3.49l.7.48c-.37-.95-.74-1.89-1.12-2.83l-.42-.24c.28.86.56 1.72.83 2.59z"
        fill="url(#ea)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M564.23 447.74l-2.93-2.06c-.86-1.41-1.73-2.82-2.62-4.21l-1.26-1.98 4.31 2.49.08.17c.56 1.26 1.11 2.52 1.65 3.79l.76 1.8zm-3.38-4.95c.04.06.08.13.12.19-.02-.05-.05-.11-.07-.16l-.05-.03z"
        fill="url(#eb)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M567.74 450.15l-5.22-3.58-.07-.16c-.53-1.26-1.08-2.52-1.64-3.77l-.73-1.63 4.37 2.52.08.15a376 376 0 012.25 4.49l.96 1.96zm-4.34-4.37l1.42.97c-.39-.79-.79-1.57-1.19-2.35l-1.1-.63c.29.67.58 1.34.86 2.01z"
        fill="url(#ec)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M556.33 441.98c-.83-1.1-1.66-2.2-2.5-3.29l-1.79-2.32 3.63 2.1.08.14c.26.46.52.92.77 1.38l.73 1.34-.92.65z"
        fill="url(#ed)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M563.63 447.33l-6.76-4.65-.53-.71-.78-1.41c-.25-.46-.51-.91-.76-1.37l-1.04-1.84 5.77 3.34.08.12c.89 1.4 1.76 2.81 2.63 4.23l1.4 2.29zm-5.95-5.45l2.2 1.5c-.37-.6-.75-1.2-1.13-1.8l-1.99-1.15.48.89.43.56z"
        fill="url(#ee)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M558.66 443.94l-1.89-1.29c-1.43-.97-2.87-1.94-4.3-2.91l-.1-.09c-1.15-1.27-2.31-2.54-3.47-3.8l-2.59-2.81 8.4 4.91c.85 1.1 1.68 2.19 2.51 3.3l.08.14 1.37 2.56zm-5.54-5.15c.55.37 1.09.74 1.64 1.11-.29-.38-.58-.75-.86-1.13l-1.67-.96.89.98z"
        fill="url(#ef)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M559.76 444.65L556.74 442.64 556.58 442.45 556.32 441.97 557.2 441.25 559.76 444.65z"
        fill="url(#eg)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M552.47 439.59l-2.21-1.33c-.93-.63-1.83-1.23-2.74-1.83-1.29-1.18-2.52-2.31-3.74-3.43l-3.59-3.27 4.21 2.31c1.31.72 2.63 1.44 3.93 2.19l.85.55c.61.87 1.21 1.75 1.81 2.63l1.49 2.18zm-4.32-4.14l.04.04c.07.04.13.09.2.13-.01-.02-.02-.03-.03-.05l-.21-.12z"
        fill="url(#eh)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M556.35 442.37l-6.26-4.28c-.6-.88-1.2-1.75-1.8-2.62l-1.49-2.14 2.89 1.71c1.17 1.26 2.33 2.53 3.48 3.81l3.18 3.52z"
        fill="url(#ei)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M547.52 436.43c-1.61-1.08-3.24-2.15-4.86-3.22l-.31-.26c-.38-.46-.77-.92-1.15-1.38l-1.97-2.36 5.28 2.91c1.23 1.12 2.46 2.25 3.68 3.38l-.66.94z"
        fill="url(#ej)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M542.67 433.21L542.39 433 539.08 428.96 543.29 432.24 542.67 433.21z"
        fill="url(#ek)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M875.92 821l-4.32-2.84-.09-.33c-.22-1.11-.42-2.22-.6-3.34l-.23-1.45 3.85 3.05.05.2c.27 1.08.57 2.14.89 3.2l.45 1.51zm-3.36-3.58l1.41.93c-.14-.51-.28-1.03-.42-1.55l-1.31-1.03c.1.56.2 1.11.31 1.66z"
        fill="url(#el)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M875 817.93l-4.05-3.21-.04-.23c-.19-1.21-.36-2.4-.49-3.55l-.18-1.56 3.53 3.39.04.18c.22 1.09.48 2.21.77 3.34l.42 1.64zm-3.03-3.86l1.14.91c-.12-.53-.24-1.07-.35-1.59l-1.04-1c.07.55.16 1.12.25 1.68z"
        fill="url(#em)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M873.82 813.07l-3.41-2.25-.03-.28c-.12-1.09-.21-2.17-.27-3.21l-.1-1.69 3.17 3.74.03.17c.11.74.24 1.47.37 2.2l.25 1.32zm-2.37-2.94l.8.53c-.04-.25-.08-.5-.12-.76l-.79-.93c.03.39.07.77.11 1.16z"
        fill="url(#en)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M874.17 814.74l-3.73-3.58-.2-1.82 3.28 2.16.05.25c.07.4.15.8.24 1.2l.36 1.79z"
        fill="url(#eo)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M873.18 809.54l-3.09-2.46v-.27c-.07-1.04-.1-2.08-.1-3.1v-1.83l2.78 4.08.02.16c.06.68.14 1.35.22 2.03l.17 1.39zm-2.01-3.07l.57.46c-.02-.18-.04-.36-.05-.54l-.56-.82c0 .3.02.6.04.89z"
        fill="url(#ep)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M873.5 811.51l-3.38-3.98-.1-1.98 2.96 2.36.03.24c.06.47.12.93.19 1.39l.3 1.96z"
        fill="url(#eq)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M872.74 805.84l-2.74-2.65v-.82l.33-3.97 2.25 4.23v.14c.02.54.04 1.08.08 1.62l.09 1.45zm-1.63-3.16l.37.35v-.08l-.35-.65v.38z"
        fill="url(#er)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M872.99 808.29L870 803.9l.02-2.28 2.62 2.54v.24c.05.58.09 1.16.15 1.73l.2 2.16z"
        fill="url(#es)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M872.5 801.99L870.25 799.34 870.4 797.56 870.84 795.06 872.64 799.58 872.5 801.99z"
        fill="url(#et)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M872.66 805.17l-2.5-4.69.22-2.75 2.21 2.62-.03.53c0 .61 0 1.26.02 1.9l.07 2.4z"
        fill="url(#eu)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M873.63 799.69l-2.87-4.19.69-3.79.64 2.33c.22.81.44 1.62.67 2.44l.87 3.21z"
        fill="url(#ev)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M872.48 802.21l-2.01-5.07.58-3.22 1.74 2.66.02.22-.33 5.41zm-.86-5.19l.06.14.02-.28-.04-.06-.03.19z"
        fill="url(#ew)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M873.23 794.97L871.49 791.69 871.55 791.45 872.17 788.51 873.23 794.97z"
        fill="url(#ex)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M872.72 798.32l-1.03-1.51c-.22-.81-.44-1.62-.67-2.43l-.04-.14.87-4.21.71 1.28-.48.3.49-.28.13.31c.12.76.24 1.52.35 2.28v.08l-.23 2.75-.1 1.58z"
        fill="url(#ey)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M872.64 800.23L870.76 793.36 872.69 796.31 872.23 796.65 872.71 796.35 872.83 796.52 872.64 800.23z"
        fill="url(#ez)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M873.02 794.51l-1.47-3.05.02-.11c.19-.86.37-1.72.55-2.58l.91-4.38.19 4.48c.04.82.07 1.64.09 2.45l-.3 3.19z"
        fill="url(#eA)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M872.61 798.47l-.66-4.38c-.11-.76-.23-1.52-.35-2.28l-.5-3.23 2.11 3.91-.6 5.98z"
        fill="url(#eB)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M873.42 790.26L872.35 787.67 872.61 786.38 873.7 786.54 873.42 790.26z"
        fill="url(#eC)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M873.31 791.39l-1.11-.04-.09-2.44v-.08l.64-3.16.84 2.07v.2c-.08 1.15-.17 2.29-.28 3.44z"
        fill="url(#eD)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M599.39 472.23c-2.88-1.78-5.78-3.53-8.68-5.28-1.85-1.12-3.7-2.24-5.55-3.37l-.96-.58-.24-3.02 2.61 1.83c4.48 3.13 8.95 6.28 13.41 9.43l-.59.99z"
        fill="url(#eE)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M585.36 463.71l-.91-.55c-1.37-.82-2.73-1.65-4.1-2.48l-.51-.31-.04-.27c-.11-.69-.23-1.37-.35-2.06l-.24-1.35 5.92 4.12.23 2.9zm-4.51-4.08l.06.03c1.06.64 2.12 1.29 3.18 1.93v-.11l-3.31-2.3.07.45z"
        fill="url(#eF)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M579.8 460.34l-4.16-2.53-.06-.23c-.23-.89-.47-1.78-.71-2.67l-.42-1.52 4.99 3.46.03.27c.08.7.15 1.39.22 2.09l.11 1.14zm-3.21-3.3l1.88 1.14c-.02-.22-.05-.44-.07-.66l-2.05-1.43c.08.31.16.63.25.94z"
        fill="url(#eG)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M581.1 461.13l-2.48-1.51-.03-.3c-.07-.69-.14-1.38-.22-2.07l-.14-1.25 2.27 1.58.04.24c.12.69.24 1.38.35 2.07l.2 1.24z"
        fill="url(#eH)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M575.12 457.5l-1.06-.64c-.75-.45-1.49-.9-2.24-1.34l-.17-.1-.07-.2c-.41-1.14-.83-2.28-1.25-3.41l-.65-1.72 4.61 3.18.05.23c.19.91.37 1.82.55 2.73l.24 1.27zm-2.58-2.9c.33.2.67.4 1 .6-.08-.41-.16-.81-.25-1.21l-1.31-.9c.19.5.37 1.01.55 1.52z"
        fill="url(#eI)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M577 458.64l-3.16-1.91-.05-.26c-.17-.91-.36-1.81-.54-2.71l-.29-1.41 2.92 2.02.06.21c.25.9.48 1.79.71 2.69l.35 1.37zm-2.17-2.67l.39.23c-.1-.37-.2-.73-.29-1.1l-.31-.21.21 1.07z"
        fill="url(#eJ)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M570.48 454.71l-2.54-1.47-.08-.17c-.68-1.46-1.37-2.9-2.08-4.35l-.96-1.96 4.13 2.83.06.2c.37 1.17.72 2.36 1.07 3.54l.4 1.38zm-2.76-4.56c.22.47.45.94.67 1.4-.12-.4-.24-.8-.37-1.2l-.3-.21z"
        fill="url(#eK)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M573.16 456.31l-1.34-.8c-.83-.5-1.67-.99-2.5-1.48l-.2-.11-.1-.24c-.34-1.18-.69-2.35-1.06-3.52l-.49-1.58 3.82 2.62.07.17c.43 1.14.85 2.28 1.26 3.43l.54 1.52zm-3.14-3.21c.34.2.68.4 1.01.59-.21-.58-.42-1.15-.64-1.72l-.88-.61c.17.58.35 1.16.51 1.73z"
        fill="url(#eL)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M565.73 451.51l-1.81-1.46c-.86-1.46-1.74-2.92-2.62-4.38l-1.39-2.29 3.49 2.39.07.16c.51 1.2 1 2.41 1.49 3.62l.78 1.95z"
        fill="url(#eM)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M569.64 454.22l-2.19-1.27-3.47-2.8-.06-.14c-.48-1.2-.97-2.4-1.48-3.6l-.76-1.8 5.02 3.44.07.14c.71 1.45 1.4 2.91 2.09 4.37l.78 1.66zm-4.75-4.8l2.02 1.63c-.35-.73-.7-1.46-1.06-2.19l-1.64-1.13c.23.56.46 1.12.68 1.68z"
        fill="url(#eN)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M566.48 452.17l-6.54-5.32c-1.01-1.4-2.04-2.79-3.07-4.17l-2.06-2.76 7.43 5.12c.89 1.46 1.77 2.92 2.63 4.39l1.61 2.73zm-5.7-6.09l1.5 1.22c-.3-.5-.61-1.01-.91-1.51l-1.6-1.09c.34.46.67.92 1.01 1.38z"
        fill="url(#eO)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M560.36 447.23l-4.44-3.59c-1.22-1.38-2.39-2.68-3.56-3.98l-3.18-3.52 3.88 2.62c1.44.97 2.87 1.94 4.3 2.91l.12.08.07.12c.52.96 1.03 1.93 1.54 2.9l1.28 2.45zm-4.08-4.9c.13.15.26.29.39.44l.15.12c-.06-.1-.11-.2-.16-.31l-.37-.25z"
        fill="url(#eP)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M563.38 449.67l-5.27-4.33c-.5-.97-1.01-1.93-1.53-2.89l-1.11-2.06 2.26 1.56c1.04 1.39 2.06 2.78 3.08 4.18l2.56 3.53z"
        fill="url(#eQ)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M551.37 440.01c-1.29-1.2-2.6-2.42-3.92-3.63l.66-.94 2.71 1.81.16.16.21.31 1.03 1.54-.85.75z"
        fill="url(#eR)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M555.92 443.63l-4.62-3.71c-.34-.51-.68-1.03-1.02-1.54l-1.79-2.62 2.34 1.48 2.34 1.59c1.17 1.3 2.34 2.61 3.5 3.92l-.75.86z"
        fill="url(#eS)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M551.43 440.06l-8.8-6.88.62-.97c1.62 1.07 3.25 2.14 4.86 3.22 1.39 1.27 2.7 2.49 4.01 3.71l-.7.91z"
        fill="url(#eT)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M564.11 450.26L564.18 450.15 564.02 450.23 562.22 447.17 564.74 449.29 564.39 449.75 564.77 449.31 564.9 449.41 565.01 449.7 564.2 450.13 564.11 450.26z"
        fill="url(#eU)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M567.45 452.95L564.68 451.35 563.96 450.08 563.12 448.02 568.06 451.98 567.45 452.95z"
        fill="url(#eV)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M565.95 452.09l-3.93-2.33c-.69-.97-1.38-1.94-2.08-2.9l-2.56-3.52 7.49 6.11.1.17.99 2.48z"
        fill="url(#eW)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M566.67 452.53L564.46 451.22 564.32 451 563.98 450.15 564.97 449.61 566.67 452.53z"
        fill="url(#eX)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M562.21 450.88l-3.03-3.51c-1.1-1.27-2.21-2.54-3.32-3.81l.75-.86 2.48 2.07c.33.64.67 1.28.99 1.92l2.13 4.18z"
        fill="url(#eY)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M564.45 451.22l-3.29-1.93-2.06-2.04c-.33-.64-.65-1.28-.99-1.91l-1.28-2.45 3.99 3.25c.7.97 1.4 1.93 2.09 2.91l1.54 2.17z"
        fill="url(#eZ)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M553.11 440.18h-1.57l-.17-.18.39-.42.25-.52-.22.47.28-.44.09.08.95 1zm-1.33-.6l.38-.4-.38.4z"
        fill="url(#fa)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M561.44 449.58l-4.21-4.07c-1.95-1.84-3.89-3.66-5.84-5.48l.7-.91 4.51 3.58c1.19 1.33 2.29 2.6 3.4 3.88l.1.15 1.35 2.84z"
        fill="url(#fb)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M559.26 447.47L559.1 447.26 557.41 443.69 560.06 446.65 559.97 446.74 560.07 446.68 560.1 446.74 559.84 446.87 559.26 447.47z"
        fill="url(#fc)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M565.29 451.7L560.48 448.89 559.23 447.43 560.02 446.6 565.29 451.7z"
        fill="url(#fd)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M557.17 447.01l-6.78-3.97c-2.62-3.42-5.31-6.8-7.99-10.04l-2.49-3.01 3.35 2.23 8.97 7.05c1.25 1.89 2.5 3.84 3.71 5.78l1.23 1.97zm-5.99-4.8l2.58 1.49c-.8-1.25-1.6-2.49-2.41-3.71l-4.94-3.86c1.6 2 3.2 4.03 4.77 6.08z"
        fill="url(#fe)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M561.5 449.51l-6.42-3.71-.08-.12c-1.21-1.93-2.45-3.87-3.7-5.76l-2.65-4.01 3.47 3.24c1.95 1.82 3.89 3.64 5.83 5.47l2.12 2.09 1.41 2.79zm-5.64-4.6l1.91 1.1-.53-.51c-.83-.78-1.65-1.55-2.47-2.33.37.58.73 1.15 1.09 1.73z"
        fill="url(#ff)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M563.52 450.69L559.72 448.49 557.72 444.55 560.02 446.61 563.52 450.69z"
        fill="url(#fg)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M878.73 822.84l-4.26-2.79-.06-.21c-.32-1.07-.62-2.16-.9-3.25l-.42-1.64 3.89 3.07.19.55c.3.88.62 1.75.94 2.61l.63 1.65zm-3.33-3.56l1.07.7c-.12-.34-.24-.67-.35-1.01l-.08-.22-1.02-.81c.12.45.25.89.39 1.34z"
        fill="url(#fh)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M877.65 820.02l-4.09-3.23-.05-.2c-.29-1.14-.56-2.29-.78-3.4l-.37-1.79 3.64 3.49.04.15c.31 1.06.64 2.1.99 3.14l.62 1.83zm-3.12-3.93l.87.69c-.13-.41-.25-.82-.37-1.23l-.82-.78c.1.44.21.88.32 1.33z"
        fill="url(#fi)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M875.84 814.4l-3.3-2.17-.05-.25c-.14-.75-.27-1.49-.38-2.25l-.3-1.96 3.33 3.92.03.14c.09.38.19.76.29 1.13l.38 1.45z"
        fill="url(#fj)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M876.64 817.1l-3.88-3.72-.04-.18-.24-1.23-.24-1.32 3.16 2.08.06.22c.18.7.38 1.4.58 2.1l.6 2.05z"
        fill="url(#fk)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M874.95 810.94l-3.01-2.39-.03-.24c-.09-.69-.16-1.38-.23-2.07l-.2-2.17 2.98 4.46c.06.29.11.58.17.87l.32 1.54z"
        fill="url(#fl)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M875.74 814.14l-3.61-4.24-.03-.17c-.07-.47-.14-.95-.2-1.42l-.18-1.39 2.86 2.27.04.21c.16.81.35 1.62.54 2.42l.57 2.32z"
        fill="url(#fm)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M874.21 807.25l-2.64-2.55v-.24c-.05-.55-.07-1.1-.09-1.66l-.07-2.39 2.52 4.84.28 2z"
        fill="url(#fn)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M874.97 811.2l-3.27-4.81-.02-.16c-.05-.59-.1-1.18-.13-1.77l-.09-1.45 2.49 2.4.03.21c.14.98.3 1.95.48 2.91l.51 2.67zm-2.19-5.23l.17.24-.03-.21-.14-.14v.11z"
        fill="url(#fo)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M874.55 804.42L871.46 800.76 871.67 797.14 874.55 804.42z"
        fill="url(#fp)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M874.34 808.35l-2.86-5.4v-.14c-.02-.66-.03-1.31-.02-1.97l.1-1.72 1.73 2.09.31.86c.08 1.05.19 2.12.33 3.18l.41 3.1z"
        fill="url(#fq)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M873.68 803.4l-1.42-1.73-.74-1.88.39-6.43.88 3.25c.22.8.43 1.61.64 2.41l.02.15c.02.84.05 1.68.11 2.52l.12 1.72z"
        fill="url(#fr)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M873.87 805.77L871.01 798.5 873.56 801.48 873.87 805.77z"
        fill="url(#fs)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M873.46 799.46l-1.77-2.59.08-1.26.63-6.06.65 4.36c.13.86.25 1.72.38 2.59l.03 2.96z"
        fill="url(#ft)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M873.54 803.74l-1.17-4.42c-.21-.8-.43-1.6-.64-2.4l-.03-.09.09-1.76 1.66 2.35.1 6.32z"
        fill="url(#fu)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M873.42 795.25L872.07 792.75 872.2 791.28 873.31 791.31 873.42 795.25z"
        fill="url(#fv)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M872.33 796.67c-.12-.86-.25-1.72-.38-2.58v-.08l.31-3.27 1.1 2.02v.15c.04 1.22.06 2.44.08 3.66l-1.1.09z"
        fill="url(#fw)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M881.22 831.14c-1.58-3.23-2.98-6.43-4.15-9.52l-.63-1.66 2.65 1.74 1.54 4.82 1.59 4.13-1.01.5zm-3.83-36.42l-.46-2.98a314.14 314.14 0 00-2.67-14.96l-.02-.1v-.11c.13-.84.24-1.68.35-2.53.31-2.73.57-5.46.76-8.11l.37-5.28.73 5.24c1.06 7.54 1.75 15.43 2.07 23.43v.15c-.17.77-.33 1.53-.49 2.3l-.63 2.94zm-2.02-18.08c.69 3.37 1.34 6.85 1.93 10.4-.26-5.36-.7-10.65-1.3-15.81-.1.98-.21 1.97-.32 2.96-.1.82-.21 1.63-.32 2.44z"
        fill="url(#fx)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M879.66 823.44l-2.52-1.64-.07-.18c-.33-.88-.65-1.76-.96-2.65l-.75-2.21 3.08 2.42.31 1.23c.09.35.17.7.27 1.05l.64 1.98z"
        fill="url(#fy)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M878.9 821l-2.86-2.25-.06-.17c-.36-1.05-.69-2.11-1.01-3.19l-.6-2.04 3.42 3.27 1.1 4.38zm-1.93-2.98l.04.03-.2-.79-.13-.13c.1.3.19.6.29.89z"
        fill="url(#fz)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M879.52 816.82l-5.08-3.33-.06-.22c-.1-.38-.2-.77-.29-1.15l-.56-2.31 5.98 7.02z"
        fill="url(#fA)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M878.32 818.7l-3.3-3.14-.04-.15c-.21-.71-.4-1.42-.59-2.14l-.38-1.45 3.07 2.14.04.11c.13.37.26.75.39 1.12.09.45.16.81.23 1.17l.58 2.33zm-2.33-3.8l.34.33c-.07-.2-.15-.42-.22-.64l-.26-.17c.05.16.09.33.14.49z"
        fill="url(#fB)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M877.6 813.06l-4.02-3.2-.04-.21c-.06-.3-.12-.59-.17-.88l-.5-2.66 4.74 6.96z"
        fill="url(#fC)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M877.63 815.57l-1.56-1.05-1.94-2.27-.03-.14c-.2-.82-.38-1.64-.55-2.47l-.31-1.53 2.23 1.8.68 1.05c.3 1.02.61 2.03.95 3.03l.53 1.58zm-2.49-3.89l.08.09c-.04-.12-.07-.24-.11-.37l-.05-.08.09.36z"
        fill="url(#fD)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M878 816.74L873.45 811.46 876.77 813.63 876.48 814.13 876.82 813.66 876.99 813.77 877.1 814 878 816.74z"
        fill="url(#fE)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M875.88 808.87L872.91 806 872.43 802.34 875.88 808.87z"
        fill="url(#fF)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M876.48 812.15l-1.92-1.55-1.19-1.83c-.19-.99-.35-1.99-.49-2.97l-.23-1.63 1.57 1.55 1.08 2.08c.21.89.45 1.77.7 2.65l.48 1.7z"
        fill="url(#fG)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M877.14 814.38L872.44 807.5 875.94 810.26 877.14 814.38z"
        fill="url(#fH)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M875.42 808.42l-2.18-2.13-.42-.87c-.14-1.08-.26-2.18-.34-3.25l-.28-3.7 2.37 6.06c.16.76.29 1.41.43 2.06l.41 1.83z"
        fill="url(#fI)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M876.36 812.16l-4.78-9.03 3.4 3.28.04.18c.09.41.18.81.28 1.21l1.06 4.36z"
        fill="url(#fJ)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M874.54 804.39l-2.06-2.43v-.2c-.07-.86-.11-1.72-.13-2.58l-.09-4.61 1.18 4.44c.23.85.45 1.7.67 2.56l.43 2.83z"
        fill="url(#fK)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M873.56 804.97l-1.07-2.8-.14-2.11 1.86 2.2.03.17c.11.74.24 1.48.38 2.21l-1.06.34z"
        fill="url(#fL)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M873.94 800.15L872.33 797.8 872.32 796.59 873.43 796.5 873.94 800.15z"
        fill="url(#fM)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M873.04 801.88c-.22-.85-.44-1.7-.67-2.55l-.02-.15-.03-3.41 1.27 1.86.02.14.45 3.35.07.52-1.09.24z"
        fill="url(#fN)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M877.03 796.26l-.59-2.15c-1.03-3.79-2.1-7.49-3.16-11.01l-.04-.14.03-.15c.37-2.12.71-4.21.99-6.23l.45-3.2.65 3.16c.99 4.82 1.89 9.87 2.68 15.02l.02.11-.02.11c-.16.77-.33 1.53-.51 2.3l-.49 2.18zm-2.65-13.38c.85 2.81 1.7 5.74 2.53 8.74-.62-3.98-1.3-7.91-2.03-11.71-.16.98-.32 1.97-.5 2.97z"
        fill="url(#fO)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M876.47 815.6l-.39-1.14-.94-2.78 2.22 2.59.18 1.01-1.07.31z"
        fill="url(#fP)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M877.57 815.55l-1.37-.92-.15-.25c-.34-1.02-.67-2.04-.97-3.07l-.99-3.41 2.89 4.24.06.2c.09.63.19 1.26.3 1.89l.22 1.32z"
        fill="url(#fQ)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M877.73 816.47L876.07 814.46 875.55 812.88 876.87 813.69 876.57 814.19 876.95 813.75 877.3 813.98 877.73 816.47z"
        fill="url(#fR)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M877.07 812.62l-2.09-1.65-.05-.18c-.25-.89-.49-1.79-.71-2.69l-1.05-4.36 2.88 5.45c.21.4.42.78.63 1.16l.21.9.18 1.38z"
        fill="url(#fS)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M877.39 814.72l-2.31-3.41-.64-2.24 2.41 1.91.03.24.15 1.11.35 2.38z"
        fill="url(#fT)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M876.58 809.53l-2.6-2.5-.04-.18c-.15-.66-.28-1.32-.41-1.99l1.06-.34 1.99 5.01z"
        fill="url(#fU)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M875.72 810.92c-.21-.38-.42-.77-.63-1.15l-.87-1.68c-.1-.41-.2-.83-.29-1.24l-.4-1.84 2.04 2.05.13.31c.33 1.06.67 2.06 1.02 3.06l-1 .5z"
        fill="url(#fV)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M874.98 804.93L873.29 802.93 873.14 802.61 873.02 801.81 874.11 801.57 874.98 804.93z"
        fill="url(#fW)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M876.29 809.27l-1.74-1.76-.99-2.54c-.17-.85-.3-1.6-.42-2.36l-.3-1.98 1.27 1.5-.42.39.48-.32.09.1.1.21.34 1.31c.28 1.09.6 2.2.94 3.31l.66 2.13z"
        fill="url(#fX)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M874.68 807.84L873.58 805.06 875.57 806.98 875.72 807.42 874.68 807.84z"
        fill="url(#fY)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M876.71 798.48l-.71-1.79c-1.14-2.85-2.29-5.7-3.47-8.55l-.06-.14.11-1.55c.24-1.26.46-2.45.67-3.64l.4-2.29.67 2.22c1.07 3.53 2.13 7.25 3.17 11.04l.04.15-.09.4-.75 4.14zm-3.11-10.67c.91 2.21 1.81 4.42 2.7 6.64l.09-.48c-.81-2.95-1.63-5.85-2.46-8.66-.08.44-.17.87-.25 1.31l-.08 1.19z"
        fill="url(#fZ)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M877.4 815.72L875.68 810.84 876.67 810.33 876.82 810.69 877.4 815.72z"
        fill="url(#ga)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M877.18 813.58l-1.45-2.65c-.4-1.11-.74-2.12-1.06-3.15l1.04-.41c.32.79.65 1.57.99 2.35l.05.18.45 3.68z"
        fill="url(#gb)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M876.51 801.05l-.88-1.66c-1.1-2.06-2.2-4.12-3.3-6.17l-.07-.13-.05-1.74c.11-1.22.2-2.36.29-3.5l.18-2.32.88 2.14c1.18 2.85 2.33 5.7 3.47 8.56l.07.16-.43 2.76-.16 1.89zm-3.15-8.28c.82 1.52 1.63 3.03 2.44 4.55l.14-.79c-.83-2.09-1.67-4.18-2.53-6.26-.03.38-.07.75-.1 1.13l.04 1.38z"
        fill="url(#gc)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M876.31 803.64l-3.78-5.55-.2-1.42c-.02-1.29-.05-2.51-.08-3.72l-.06-2.35 1.1 2.04c1.11 2.06 2.21 4.11 3.31 6.17l.08.16-.37 4.66zm-2.72-6l1.87 2.74.09-1.14-2.13-3.99c0 .44.01.89.02 1.33l.15 1.06z"
        fill="url(#gd)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M876.44 806.64l-3.13-3.69-.28-1.08-.08-.58c-.15-1.14-.29-2.25-.45-3.36l-.33-2.37 4.27 6.27-.06.78c-.02.78-.01 1.6.01 2.42l.04 1.6zm-2.12-4.26l.95 1.12c0-.31 0-.63.01-.94l.03-.39-1.39-2.03c.04.33.09.66.13.98l.07.52.2.74z"
        fill="url(#ge)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M876.69 809.64l-2.07-1.99-.05-.15c-.35-1.13-.67-2.25-.95-3.35l-.96-3.73 3.73 4.4v.22c.03 1.01.09 2.05.17 3.1l.12 1.49zm-1.7-4.71c.11.4.22.8.34 1.2l-.03-.84-.31-.37z"
        fill="url(#gf)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M877.13 813.56l-1.46-3.35c-.34-.79-.67-1.58-1-2.38l-.77-2.45 2.64 2.54.02.23c.05.58.1 1.17.17 1.75l.4 3.66z"
        fill="url(#gg)"
        stroke="#40a840"
        strokeMiterlimit={10}
      />
      <Path
        d="M1391.7 622.87c.12 52.64.19 105.28-.17 157.91-.25 37.35-.72 74.7-1.55 112.04-.76 34.27 3.24 71.18-13.61 102.23-8.75 16.13-22.09 29.12-37.6 38.77-7.45 4.64-15.52 8.05-23.27 12.09-45.18 23.51-90.3 47.15-135.44 70.73-19.91 10.4-39.86 20.73-59.78 31.13-46.52 24.28-93.03 48.59-139.54 72.89-29.64 15.48-59.28 30.96-88.92 46.46-39.36 20.58-78.68 41.23-118.11 61.69-10.71 5.56-22.34 8.73-34.1 11.17-14.81 3.08-29.82 4.68-44.95 4.08-27.38-1.09-53.58-6.87-78.03-19.79-33.97-17.94-68.09-35.58-102.13-53.38-36.93-19.31-73.84-38.65-110.76-57.97l-105.75-55.35c-44.82-23.46-89.65-46.91-134.47-70.36-29.94-15.66-59.89-31.29-89.82-46.94-12.21-6.38-23.69-13.84-33.83-23.22-18.09-16.73-29.12-37.43-34.58-61.29C2.18 942.19.6 928.42.18 914.54c-.33-10.91-.07-21.84-.07-32.89 1.15-.31 1.75.99 2.53 1.77 32.65 32.35 69.88 58.47 109.92 80.79 31.79 17.72 64.73 33.07 97.91 47.95 26.13 11.71 52.23 23.47 78.64 34.53 27.19 11.39 54.43 22.67 81.67 33.95 35.16 14.56 70.27 29.22 105.51 43.58 25.55 10.41 51.25 20.47 76.93 30.58 21.69 8.55 43.05 17.89 64.58 26.82 16.01 6.64 32.35 12.22 49.4 15.69 28.06 5.71 54.99 3.05 81.42-8.41 35.85-15.54 72.09-30.21 108.16-45.25 41.13-17.15 82.27-34.31 123.4-51.45 35.44-14.77 70.9-29.51 106.34-44.27 40.04-16.67 80.16-33.14 120.07-50.09 27.73-11.77 44.01-33.47 51.6-62.15 3.39-12.82 4.66-25.95 5.03-39.14.46-16.29-.73-32.53-1.69-48.79-1.12-19-1.39-38.03-1.35-57.07.1-49.91.16-99.82.22-149.74 0-3.94.03-7.85-1-11.74-1.45-5.48-4.63-9.46-9.53-12.17-3.33-1.84-6.95-2.91-10.55-4.03-36.31-11.32-72.63-22.65-108.95-33.95-64.95-20.21-129.91-40.4-194.87-60.59-45.16-14.04-90.52-27.35-136.35-39.06-31.53-8.05-63.2-15.57-95.3-20.97-18.43-3.1-37.04-5-55.78-4.29-21.96.84-43.22 4.83-63.06 14.78-1.87.94-3.69 1.65-5.88 1.34-11.4-1.63-22.87-1.98-34.37-1.77-50.57.94-96.38 15.87-136.79 46.6-2.59 1.97-5.17 3.96-7.78 5.92-2.79 2.1-2.73 2.02-5.24-.68-5.76-6.18-7.22-13.86-7.58-21.84-.24-5.31-.06-10.63-.06-15.95.01-31.9.07-63.81 0-95.71-.01-5.16.33-10.28.99-15.37 1.05-8.13 5.46-14.31 11.93-19.08 8.43-6.22 17.6-11.3 26.49-16.8 38.78-24.01 77.62-47.93 116.44-71.88 41.3-25.48 82.61-50.95 123.94-76.39 4.97-3.06 10.18-5.67 15.69-7.67 8.68-3.14 17.41-3.24 26.26-.72 6.96 1.98 13.55 4.84 20.02 8.02 29.08 14.32 58.11 28.73 87.25 42.92 42.86 20.87 85.78 41.63 128.73 62.32 30.12 14.51 60.3 28.92 90.53 43.21 50.24 23.75 100.23 48.01 149.61 73.48 65.12 33.6 128.76 69.75 189.46 110.91 17.33 11.75 16.88 22.12 16.92 41.74.04 20.43.09 40.87.14 61.3z"
        fill="#58bfea"
      />
      <Path
        d="M714.16.48c3.94 1.62 8.22 1.11 12.31 1.65 12.97 1.7 25.58 4.72 37.92 8.99 4.25 1.47 8.03 3.85 11.97 5.92 23.69 12.43 47.39 24.83 71.08 37.27 48.59 25.51 97.16 51.02 145.74 76.54 32.79 17.22 65.57 34.46 98.36 51.69 40.99 21.53 81.98 43.05 122.96 64.59 28.97 15.23 57.92 30.49 86.86 45.78 2.88 1.52 5.85 2.84 8.87 4.05 16.58 6.66 32.01 15.18 45.2 27.25 17.57 16.09 27.77 36.31 32.76 59.34.93 4.3 2.3 8.59 2.12 13.14-1.87.54-3.06-.63-4.33-1.27-65.4-33.07-132.98-61.14-201.3-87.52-44.61-17.23-89.83-32.77-134.92-48.67-61.09-21.54-122.21-43.02-183.31-64.54-37.5-13.21-74.85-26.84-112.58-39.4-16.11-5.36-32.56-9.51-49.43-11.69-20.15-2.6-39.98-.77-59.59 4.41-18.77 4.96-36.79 12.05-54.92 18.85-38.68 14.49-77.33 29.05-115.99 43.59-44.92 16.89-89.83 33.79-134.74 50.68-41.55 15.62-83.1 31.22-124.65 46.85-12.67 4.77-25.34 9.49-37.32 15.94-23.12 12.45-35.87 32.13-40.91 57.38-2.58 12.97-3.7 26.09-4.16 39.28-.79 22.78-1.44 45.56-2.34 68.34-.83 21.23-2.31 42.45-1.75 63.72.2 7.73 1.47 15.34 3.5 22.79 4.09 15.04 13.01 26.62 25.73 35.43 7.21 4.99 14.78 9.36 22.61 13.26 57.12 28.41 114.2 56.89 171.42 85.11 43.52 21.47 87.16 42.69 130.85 63.82 43.38 20.98 86.65 42.2 129.59 64.07 17.57 8.95 35.02 18.15 52.55 27.17 5.34 2.75 10.93 4.9 16.58 6.96 14.21 5.18 28.24 4.35 42.19-.89 6.26-2.35 12.36-5.1 18.35-8.07 35.51-17.56 71.18-34.81 106.47-52.79 10.19-5.19 18.53-10.71 27.86-15.44 4.11-2.09 8.4-4.02 13.13-5.7 28.42-10.13 68.87-28.62 96.38-41.05 22.67-10.25 34.92-19.32 48.7-33.48 1.5-1.61 7.07-.08 9.11 1.25 2.87 1.87 5.93 3.45 8.85 5.23 9.49 5.76 13.88 14.42 13.97 25.32.13 15.78.12 31.56.14 47.34.03 23.5 0 46.99.05 70.49.01 5.51-.51 10.94-1.56 16.34-2.72 14.08-11.53 23.77-22.85 31.67-18.7 13.05-37.39 26.13-56.09 39.17-51.19 35.7-102.38 71.41-153.59 107.09-35.45 24.7-70.92 49.38-106.39 74.06-4.64 3.23-9.38 6.34-13.93 9.7-9.65 7.14-19.24 6.89-29.08.34-14.56-9.69-29.22-19.24-43.83-28.85-41.69-27.42-83.38-54.85-125.07-82.27-54.29-35.72-108.58-71.45-162.88-107.17-39.83-26.2-79.66-52.39-119.49-78.58-32.81-21.58-65.79-42.9-98.39-64.79-42-28.2-83.69-56.84-125.52-85.29-.71-.48-1.33-1.14-2.1-1.47-3.42-1.48-3.82-4.23-3.82-7.58.07-83.35-.03-166.7.14-250.06.03-16.43.56-32.89 2.85-49.22 4.06-28.98 14.41-54.92 36.42-75.22 10.3-9.5 22.01-16.89 34.5-23.1 6.91-3.43 13.93-6.64 20.85-10.05 37.52-18.52 75.02-37.08 112.54-55.61 57.66-28.48 115.32-56.95 172.98-85.42S497.11 80.2 554.77 51.73c23.68-11.69 47.33-23.45 71.06-35.02 15.69-7.65 32.41-11.89 49.64-14.41 4.84-.71 9.86-.16 14.49-2.29l24.14.48z"
        fill="#58bfea"
      />
    </Svg>
  )
}

export default SSLogo
